import { Component, ElementRef, OnInit, OnDestroy, ViewChild, Renderer2, ChangeDetectorRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormBuilder } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { skip } from 'rxjs/operators';

import { CalendarOptions, createElement, FullCalendarComponent } from '@fullcalendar/angular'; // useful for typechecking
import momentTimezonePlugin from '@fullcalendar/moment-timezone'
import momentPlugin from '@fullcalendar/moment';
import resourceTimeGridPlugin from '@fullcalendar/resource-timegrid';

import { DrupalRESTService } from 'src/app/services/drupal-rest.service';
import { RefreshService } from 'src/app/services/refresh.service';
import { EntityRESTService } from 'src/app/services/entity-rest.service';
import { FieldsService } from 'src/app/services/fields.service';
import { TaxonomyService } from 'src/app/services/taxonomy.service';
import { AuthRESTService } from 'src/app/services/auth-rest.service';
import { MenuRESTService } from 'src/app/services/menu-rest.service';
import { RouteEventsService } from 'src/app/route-events.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import { ConfigPagesService } from 'src/app/services/config-pages.service';
import { PackagesService } from 'src/app/services/packages.service';
import { UserService } from 'src/app/services/user.service';
import { ComponentRefreshService } from 'src/app/services/component-refresh.service';
import { TranslateService } from '@ngx-translate/core';
import { LessonComponent } from 'src/app/components/forms/lesson/lesson.component';
import { GroupLessonComponent } from 'src/app/components/forms/group-lesson/group-lesson.component';
import { SchedulesComponent } from 'src/app/components/forms/schedules/schedules.component';
import { ServicesComponent } from 'src/app/components/forms/services/services.component';
import { StudentAccountComponent } from 'src/app/components/forms/student-account/student-account.component';
import { AppointmentDetailsComponent } from 'src/app/components/forms/appointment-details/appointment-details.component';
import { InquiryComponent } from 'src/app/components/forms/inquiry/inquiry.component';
import { StudioConfigService } from 'src/app/services/studio-config.service';
import { EventColorService } from 'src/app/services/event-color.service';

import $, { data } from "jquery";
import moment from 'moment';
import 'moment-timezone';
import { ComponentType } from '@angular/cdk/portal';
import { UtilityService } from 'src/app/services/utility.service';
import { Router, ActivatedRoute } from '@angular/router';
import { EventLessonEntityComponent } from '../forms/event-lesson-entity/event-lesson-entity.component';
import { PaymentsEntityComponent } from '../forms/payments-entity/payments-entity.component';
import { DialogService } from 'src/app/services/dialog.service';
import { EventSchedulesEntityComponent } from '../forms/event-schedules-entity/event-schedules-entity.component';
import { StudentInquiryEntityComponent } from '../forms/student-inquiry-entity/student-inquiry-entity.component';
import { BookingMenuChoice } from '../shared/booking-menu/booking-menu.component';
import { EventGroupLessonEntityComponent } from '../forms/event-group-lesson-entity/event-group-lesson-entity.component';
import { EventServicesEntityComponent } from '../forms/event-services-entity/event-services-entity.component';
import { UpdateLessonComponent } from '../forms/update-lesson/update-lesson.component';
import { UpdateGroupLessonComponent } from '../forms/update-group-lesson/update-group-lesson.component';
import { UpdateServiceComponent } from '../forms/update-service/update-service.component';
import { PrintAttendanceComponent } from './print-attendance/print-attendance.component';
import { DayViewFrmFilterComponent } from './day-view-frm-filter/day-view-frm-filter.component';
import { AuthService } from 'src/app/services/auth.service';
import { WeekCalculationService } from 'src/app/services/week-calculation.service';
import { StandingSeriesDialogComponent } from '../forms/standing-series/standing-series-dialog.component';
import { SeriesScopeDialogComponent, SeriesScopeResult } from '../../components/utility/series-scope-dialog/series-scope-dialog.component';
import { StudentDashboardWrapperComponent } from '../student/student-dashboard-wrapper/student-dashboard-wrapper.component';

// Tippy JS
import { createPopper } from '@popperjs/core';
import tippy from 'tippy.js';
import { hideAll } from 'tippy.js';
import { roundArrow } from 'tippy.js';
import { BaseComponent } from '../forms/base-form/base-form.component';
import { buildOfficeBusinessHours, getCalendarTimeFormat } from 'src/app/constants/calendar.constants';
import { StudioTaxService } from 'src/app/services/studio-tax.service';
import { environment } from 'src/environments/environment';
import { LoggerService } from '../../services/logger.service';

/**
 * IMPORTANT NOTE: Year Boundary Fix
 *
 * This component uses WeekCalculationService for handling dates at year boundaries.
 *
 * The issue:
 * When viewing dates like Sunday, December 29, 2024, which should be considered
 * part of week 1 of 2025, the API was incorrectly receiving 2024 as the year parameter.
 *
 * The fix:
 * WeekCalculationService provides `getCorrectYearForWeek()` and `calculateWeekInfo()`
 * methods to properly determine the correct year for week-based calculations,
 * especially for dates at the end of December that belong to week 1 of the next year.
 *
 * See WeekCalculationService for more details.
 */

@Component({
  selector: 'app-day-view',
  templateUrl: './day-view.component.html',
  styleUrls: ['./day-view.component.css']
})
export class DayViewComponent extends BaseComponent implements OnInit, OnDestroy {

  @ViewChild('instructorInfo') instructorInfo;
  @ViewChild('calendar') override calendarComponent: FullCalendarComponent;
  @ViewChild('customPopover') customPopover: ElementRef;
  @ViewChild('instructorToggleComponent', { read: ElementRef }) instructorToggleRef: ElementRef;
  @ViewChild('filterComponent') filterComponent: DayViewFrmFilterComponent;

  // Add properties for studio information
  studioTimezone: string = '';
  studioCountry: string = '';

  LessonComponent = LessonComponent;
  GroupLessonComponent = GroupLessonComponent;
  SchedulesComponent = SchedulesComponent;
  ServicesComponent = ServicesComponent;
  StudentAccountComponent = StudentAccountComponent;
  InquiryComponent = InquiryComponent;
  EventLessonEntityComponent = EventLessonEntityComponent
  PaymentsEntityComponent = PaymentsEntityComponent
  EventScheduleEntityComponent = EventSchedulesEntityComponent;
  StudentInquiryEntityComponent = StudentInquiryEntityComponent;
  EventGroupLessonEntityComponent = EventGroupLessonEntityComponent;
  EventServicesEntityComponent = EventServicesEntityComponent;
  UpdateLessonComponent = UpdateLessonComponent;
  UpdateGroupLessonComponent = UpdateGroupLessonComponent;
  UpdateServiceComponent = UpdateServiceComponent;

  copyData = {};
  contextMenuStandingSeriesId: number | null = null;
  contextMenuEventInfo: any = null;
  AMTDayView: any = "";
  AMTConfiguration: any = "";
  InstructorList: {} = "";
  AMTCalendarConfiguration: any = "";

  Events: any;
  Resources = {};

  // Filter configuration
  filterInstructorCategory: string[];
  filterLessonType: any;
  filterInstructor: string[] = [];
  filterStudent: string = "";
  filterDate: Date | string = "";
  filterGroupLesson: boolean = false;
  filterLesson: boolean = false;
  filterServices: boolean = false;
  filterHiddenEvents: boolean = false;

  // Resources array for instructor toggle component
  resourcesArray: { id: string, title: string }[] = [];

  get instructorToggleStorageScope(): string | null {
    const studio = this._authService.selectedStudio;
    if (studio?.id) {
      return `studio-${studio.id}`;
    }
    return studio?.key || studio?.name || null;
  }

  // Store all available resources for filtering
  private allResources: any[] = [];
  private currentlyVisibleResources: Set<string> = new Set();

  // FullCalendar
  currentSelectedInstructorID;
  currentSelectedDuration;
  currentSelectedStartTime;

  summaryCount = {
    privateLessonDaily: 0,
    privateLessonWeekly: 0,
    privateTakenLessonDaily: 0,
    privateTakenLessonWeekly: 0,
  }

  // Coaching shown as its own header fraction, excluded from the main
  // Overall Summary numbers. Sourced from the 'coaching' category bucket.
  summaryCoaching = {
    bookedDaily: 0,
    takenDaily: 0,
    bookedWeekly: 0,
    takenWeekly: 0,
  }

  // Per-category breakdown (DE / Pre / Bonus / Front / Back / Coaching / Other)
  // backing the Overall Summary dropdown. Aggregated across all instructors from
  // each resource's categoryBreakdown returned by the backend.
  summaryBreakdown: {
    key: string;
    label: string;
    bookedDaily: number;
    takenDaily: number;
    bookedWeekly: number;
    takenWeekly: number;
  }[] = [];

  newDateStart: string;
  newDateEnd: string;
  AMTSessionTime: Object;

  tippyHideDuration = 100;
  tippyInstructorHoverInstances = new Map();
  tippyEventHoverInstances = new Map();
  weekNumber: string;

  intervalId = setInterval(() => {
    this.refreshCalendar();
  }, 60000);
  noTippy: boolean = false;

  // Timer interval for studio time display
  timerIntervalId: any;

  // Flag to prevent refreshing during drag operations
  isDragging: boolean = false;

  // Flag to track if calendar is fully initialized
  private isCalendarReady: boolean = false;

  // Flag to track if a studio change occurred during initialization
  private pendingStudioRefresh: boolean = false;

  // Flag to track if studio timezone has been loaded (public for template access)
  studioTimezoneLoaded: boolean = false;

  // Custom hover tooltip
  private nextEventsCache = new Map<string, any>();
  // Map to track in-flight API requests
  private pendingRequests = new Map<string, Promise<any>>();
  // Subscription for studio changes
  private studioChangeSubscription: Subscription;
  // Menu-triggered calendar refreshes, studio config and tax mode are app-lifetime
  // streams; each must be released on destroy or the day view (and its calendar)
  // stays alive and keeps reacting after navigating away.
  private calendarRefreshSubscription: Subscription;
  private studioConfigSubscription: Subscription;
  private paymentsDueTaxSubscription: Subscription;

  constructor(
    public override _refreshService: RefreshService,
    public override _dialogService: DialogService,
    public override _entityRESTService: EntityRESTService,
    public override _utilityService: UtilityService,
    public override _fieldsService: FieldsService,
    public override _drupalRESTService: DrupalRESTService,
    public override _taxonomyService: TaxonomyService,
    public override _router: Router,
    public override _activatedRoute: ActivatedRoute,
    public override _authRESTService: AuthRESTService,
    public override _authService: AuthService,
    public override _menuRESTService: MenuRESTService,
    public override _formBuilder: FormBuilder,
    public override _routeEventsService: RouteEventsService,
    public override _permissionsService: PermissionsService,
    public override _renderer2: Renderer2,
    public override _configPages: ConfigPagesService,
    public override _packagesService: PackagesService,
    public override _snackBar: MatSnackBar,
    public override _userRESTService: UserService,
    public override _el: ElementRef,
    public override _changeDetectorRef: ChangeDetectorRef,
    public override _sanitizer: DomSanitizer,
    public override _studioConfigService: StudioConfigService,
    public override _componentRefreshService: ComponentRefreshService,
    public override _translateService: TranslateService,
    private weekCalculationService: WeekCalculationService,
    private _eventColorService: EventColorService,
    private _studioTaxService: StudioTaxService
  ) {
    super(
      _refreshService,
      _dialogService,
      _entityRESTService,
      _utilityService,
      _fieldsService,
      _drupalRESTService,
      _taxonomyService,
      _router,
      _activatedRoute,
      _authRESTService,
      _authService,
      _menuRESTService,
      _formBuilder,
      _routeEventsService,
      _permissionsService,
      _renderer2,
      _configPages,
      _packagesService,
      _snackBar,
      _userRESTService,
      _el,
      _changeDetectorRef,
      _sanitizer,
      _studioConfigService,
      _componentRefreshService,
      _translateService
    );
  }

  ngOnInit(): void {
    // Disable drag-and-drop for users without lessons_edit permission.
    const canEdit = this._permissionsService.canAccess('lessons_edit');
    this.calendarOptions.editable = canEdit;
    this.calendarOptions.droppable = canEdit;

    this.getAMTCalendarConfiguration();
    this.getAMTFilterConfiguration();
    this.getAMTSessionTime();
    this.loadStudioTimeZoneInfo();

    // Subscribe to calendar refresh events from the ComponentRefreshService
    // This handles refreshes triggered from menu actions (Add Enrollment, Add Package, Add Payment)
    this.calendarRefreshSubscription = this._componentRefreshService.calendarRefresh$.subscribe(() => {
      LoggerService.log('Calendar refresh triggered from menu action');
      this.refreshCalendarWithDatePreservation();
    });

    // Subscribe to studio changes to reload session configuration.
    // skip(1) drops the BehaviorSubject's replay of the current value. ngOnInit already loaded
    // the initial studio's data directly, so only act on *subsequent* studio changes.
    this.studioChangeSubscription = this._authService.selectedStudioChanged.pipe(skip(1)).subscribe(studio => {
      if (studio) {
        LoggerService.log('[STUDIO] Studio changed, reloading session configuration');

        // Clear only the session time cache
        this.clearSessionTimeCache();

        // Clear the studio timezone so we know it needs to be reloaded
        this.studioTimezone = '';
        this.studioCountry = '';
        this.studioTimezoneLoaded = false;

        // Mark that we need to refresh once dependencies are loaded
        this.pendingStudioRefresh = true;

        // Force reload studio timezone and refresh when complete
        this.loadStudioTimeZoneInfo();

        // Force refresh session configuration
        this.getAMTSessionTime(true);
      }
    });
  }

  ngOnDestroy(): void {
    // Close all dialogs, otherwise dialogs will stay open when navigating.
    this._dialogService.closeAll();

    // Clean up all tooltip instances to prevent memory leaks
    this.cleanupEventTooltips();

    this.detachPopoverDismissListener();

    // Unsubscribe from studio changes
    if (this.studioChangeSubscription) {
      this.studioChangeSubscription.unsubscribe();
    }
    this.calendarRefreshSubscription?.unsubscribe();
    this.studioConfigSubscription?.unsubscribe();
    this.paymentsDueTaxSubscription?.unsubscribe();

    // Clean up instructor tooltip instances
    this.tippyInstructorHoverInstances.forEach((instance, resourceId) => {
      try {
        if (instance && typeof instance.destroy === 'function') {
          instance.destroy();
        }
      } catch (error) {
        LoggerService.error(`[TOOLTIP] Error destroying instructor tooltip instance for resource ${resourceId}:`, error);
      }
    });
    this.tippyInstructorHoverInstances.clear();

    clearInterval(this.intervalId);
    if (this.timerIntervalId) {
      clearInterval(this.timerIntervalId);
    }
  }

  openEntityComponent(component: ComponentType<unknown>, eckType: any, bundle: any, action: any, EntityID?: any, fieldsData?: {}) {
    // LoggerService.log('fieldsData')
    // LoggerService.log(fieldsData)
    this._dialogService.openDialog(component, "defaultLargeWithData", {
      data: {
        EntityID: EntityID,
        eckType: eckType,
        bundle: bundle,
        action: action,
        fieldsData: fieldsData ?? '',
      },
    }).afterClosed().subscribe(data => {
      this.refreshCalendar();
    });
  }

  public dialogAddLessonData(configOptions) {
    configOptions['data'] = {
      instructors: this.filterInstructorCategory,
      lesson_types: this.filterLessonType
    };
    return configOptions;
  }

  /**
   * Utility to open dialogs with a default configuration.
   *
   * @param formName
   * @param dialogConfig
   */
  public openDialog(formName: ComponentType<unknown>, configName?, data?) {
    this._dialogService.openDialog(formName, configName, data)
      .afterClosed()
      .subscribe(result => {
        // Skip refresh if the dialog already triggered one (e.g., after delete)
        if (result?.refreshed) {
          return;
        }
        // wait 1 second and refresh the calendar.
        setTimeout(() => {
          this.refreshCalendar();
        }, 1000);
      });
  }

  /**
   * FullCalendar Configuration.
   */
  calendarOptions: CalendarOptions = {
    timeZone: 'America/New_York', // Temporary default, will be replaced with studio timezone before calendar renders
    plugins: [momentPlugin, momentTimezonePlugin, resourceTimeGridPlugin],
    firstDay: 0,
    schedulerLicenseKey: 'CC-Attribution-NonCommercial-NoDerivatives',
    initialView: 'resourceTimeGridDay',
    height: "auto",
    refetchResourcesOnNavigate: true,
    allDaySlot: false,
    // Don't allow events to overlap.
    slotEventOverlap: false,
    droppable: true,
    editable: true,
    // The Website Booking column (resource flagged webBookings by the server)
    // is a tray of online bookings waiting for a teacher, not a person: tint
    // its header and say what to do with it. Other columns keep the default.
    resourceLabelClassNames: (arg: any) => arg.resource?.extendedProps?.['webBookings'] ? ['bg-warning-subtle'] : [],
    resourceLabelContent: (arg: any) => {
      if (!arg.resource?.extendedProps?.['webBookings']) { return undefined; }
      return {
        html: `<span class="material-icons align-text-bottom" style="font-size: 16px;">language</span> ${this.escapeHtml(arg.resource.title)}`
          + '<div class="small fw-normal text-muted">Drag onto a teacher</div>'
      };
    },
    // Set to true to handle events spanning midnight properly
    nextDayThreshold: '00:00:00',
    // Force sticky headers for page scrolling
    stickyHeaderDates: true,

    events: this.getCalendarEvents(),
    resources: this.getCalendarResources(),

    loading: (isLoading) => {
      if (isLoading) {
        LoggerService.log('[CALENDAR] Loading started');
      } else {
        LoggerService.log('[CALENDAR] Loading complete');

        // Mark calendar as ready
        this.isCalendarReady = true;

        // Hide custom popover if mouse hover exits.
        $("#custom-popover").hover(null, function () {
          $(this).hide();
        });
        // Hide custom context menu if mouse hover exits.
        $("#custom-context-menu").hover(null, function () {
          $(this).hide();
        });

        // Mount the instructor toggle component in the header toolbar
        this.mountInstructorToggleInHeader();

        // Apply initial resource filtering after calendar loads
        setTimeout(() => {
          this.applyResourceFiltering(this.filterInstructor);
        }, 100);

        // Attach time slot hover tooltips
        this.attachSlotTimeTooltips();

        // Process any pending studio refresh
        this.processPendingStudioRefresh();
      }
    },

    eventDrop: (info: any) => {
      let eventID = info?.oldEvent?._def?.extendedProps?.entityId;
      let eventType = info?.event?._def?.extendedProps?.appointmentType;
      // Use studio timezone for consistent time handling
      let newStartTime = this.studioTimezone
        ? moment.tz(info.event.start, this.studioTimezone).format('YYYY-MM-DDTHH:mm:ss')
        : moment(info.event.start).format('YYYY-MM-DDTHH:mm:ss');
      let newInstructor = info?.newResource?._resource?.id;
      // Dragged out of the Website Booking column: the server moves the
      // lesson's pre-chat along with it (ami_booking_events_presave).
      const fromWebBookings = !!info?.oldResource?.extendedProps?.['webBookings'];
      const assignedTo = info?.newResource?.title || 'the teacher';
      // field_status is the attendee-resolved status; a group lesson with mixed
      // attendee statuses has none, so also lock when any attendee is charged.
      let isPosted = info?.event?._def?.extendedProps?.['eventDetails']?.data?.field_status == '59'
        || !!info?.event?._def?.extendedProps?.['groupHasPosted'];
      // hideAll() to hide all tippy instances.
      hideAll({ duration: this.tippyHideDuration });
      this.noTippy = true;

      // Set dragging flag to prevent periodic refreshes
      this.isDragging = true;

      // If the event is posted, revert the move and show message
      if (isPosted) {
        info.revert();
        this.showSnackbar('Posted events cannot be moved.');
        this.isDragging = false;
        return;
      }

      let patchData = {
        'field_date_and_time': newStartTime,
      };

      if (eventType === 'schedules') {
        patchData['field_schedule_instructor'] = newInstructor;
      } else if (eventType === 'services') {
        patchData['field_executive'] = newInstructor;
      } else {
        patchData['field_instructor'] = newInstructor;
      }

      this._entityRESTService.patchEntity('events', eventType, eventID, patchData).subscribe({
        next: () => {
          if (fromWebBookings && eventType === 'lesson' && newInstructor && newInstructor !== info?.oldResource?.id) {
            this.showSnackbar(`Web booking assigned to ${assignedTo}; its pre-chat moved too.`);
          }
          // A successful PATCH is authoritative here. The API response shape does not
          // reliably echo the updated datetime in a format suitable for client-side
          // equality checks, so trust the 2xx response and let the calendar refresh.
        },
        error: (error) => {
          // Handle any errors from the API
          info.revert(); // Revert on error
          this.showSnackbar('An error occurred while updating.');
        },
        complete: () => {
          this.noTippy = false;
          this.isDragging = false; // Reset dragging flag
          this.refreshCalendar(); // Refresh to show the new position
        }
      });
    },

    // Change in duration
    eventResize: (eventResizeInfo: any) => {
      let eventID = eventResizeInfo?.oldEvent?._def?.extendedProps?.entityId;
      let eventType = eventResizeInfo?.event?._def?.extendedProps?.appointmentType;
      let standingSeriesId = eventResizeInfo?.event?._def?.extendedProps?.['standingSeriesId'];
      let newDuration = this.calcDuration(eventResizeInfo.event.start, eventResizeInfo.event.end);

      // hideAll() to hide all tippy instances.
      hideAll({ duration: this.tippyHideDuration });
      this.noTippy = true;

      // Set dragging flag to prevent periodic refreshes
      this.isDragging = true;

      // If this is a standing series lesson, prompt for scope
      if (standingSeriesId && eventType === 'lesson') {
        const dialogRef = this._dialogService.openDialog(SeriesScopeDialogComponent, 'defaultWithData', {
          title: 'Change Duration',
          message: 'This event is part of a standing series. Do you want to change only this occurrence or all future events in the series?',
          singleLabel: 'This Event Only',
          allLabel: 'All Future Events',
        });

        // Handle cancel (dialog closed without selection)
        dialogRef.afterClosed().subscribe((result: SeriesScopeResult) => {
          if (!result) {
            eventResizeInfo.revert();
            this.noTippy = false;
            this.isDragging = false;
          }
        });

        // Handle scope selection: dialog stays open with spinner while API runs
        const instance = dialogRef.componentInstance as SeriesScopeDialogComponent;
        instance.scopeSelected$.subscribe((scope: SeriesScopeResult) => {
          this._drupalRESTService.httpPOST(
            `/api/standing-series/${standingSeriesId}/edit-future`,
            {
              scope: scope,
              event_id: scope === 'single' ? eventID : undefined,
              from_date: moment().format('YYYY-MM-DD'),
              changes: { field_duration: newDuration },
              confirm: true,
            }
          ).subscribe(() => {
            dialogRef.close(scope);
            this.noTippy = false;
            this.isDragging = false;
            this.refreshCalendar();
          });
        });
        return;
      }

      this._entityRESTService.patchEntity('events', eventType, eventID, {
        'field_duration': newDuration,
      }).subscribe((data) => {
        this.noTippy = false;
        this.isDragging = false; // Reset dragging flag
        this.refreshCalendar();
      });
    },

    eventContent: (arg: any) => {
      // Confirmation status for events.
      let isConfirmed = arg.event._def.extendedProps?.['eventDetails']?.data?.isConfirmed;
      let lessonType = arg.event._def.extendedProps?.['appointmentType'];

      // This is where the meat of content comes through.
      let contentToShow = document.createElement('div');
      contentToShow.innerHTML = arg.event._def.extendedProps['dataToShow'];

      // Add confirmation status.
      let confirmationStatus = document.createElement('div');
      confirmationStatus.className = "confirmation-status";

      // Only show confirmations for regular lessons.
      if (isConfirmed && lessonType == 'lesson') {
        confirmationStatus.innerHTML = '<span class="material-icons">check_box</span>';
      } else if (isConfirmed == false && lessonType == 'lesson') {
        confirmationStatus.innerHTML = '<span class="material-icons">check_box_outline_blank</span>';
      }

      // Makes confirmation clickable.
      confirmationStatus.addEventListener("click", (e: Event) => {
        e.stopPropagation();
        this.toggleEventConfirmation(arg);
      })

      // Notes icon
      let notesIcon = document.createElement('div');
      notesIcon.className = "notes-icon";
      notesIcon.innerHTML = '<span class="material-icons">notes</span>';

      // Check if the event has notes
      let hasNotes = arg.event._def.extendedProps?.['eventDetails']?.data?.field_notes || arg.event._def.extendedProps?.['eventDetails']?.data?.field_reason_for_canceling;
      if (!hasNotes) {
        notesIcon.style.display = 'none';
      }

      notesIcon.addEventListener("click", (e: Event) => {
        e.stopPropagation();
      });

      // Payment reminder icon
      let paymentIcon = document.createElement('div');
      paymentIcon.className = "payment-icon";

      // Only show payment reminder for lessons and when payment is needed
      if (lessonType === 'lesson' && arg.event._def.extendedProps?.['eventDetails']?.data?.field_calendar_payment_reminder) {
        paymentIcon.innerHTML = '<span class="material-icons" style="color: #FFD700; text-shadow: 0 0 2px black;">attach_money</span>';
      } else {
        paymentIcon.style.display = 'none';
      }

      // Booked online badge: the student booked this lesson themselves through
      // the website widget, so staff know to confirm it and may move it.
      let bookedOnlineIcon = document.createElement('div');
      bookedOnlineIcon.className = "booked-online-icon";
      if (lessonType === 'lesson' && arg.event._def.extendedProps?.['eventDetails']?.data?.bookedOnline) {
        bookedOnlineIcon.innerHTML = '<span class="material-icons" title="Booked online">language</span>';
      } else {
        bookedOnlineIcon.style.display = 'none';
      }

      let arrayOfDomNodes = [confirmationStatus, contentToShow, notesIcon, paymentIcon, bookedOnlineIcon];

      return { domNodes: arrayOfDomNodes }
    },

    eventDidMount: (info) => {
      // No-enrollment indicator: red left stripe for lessons missing an enrollment
      const bundle = info.event._def?.extendedProps?.['appointmentType'];
      const enrollmentInfo = info.event._def?.extendedProps?.['enrollmentInfo'];
      if (bundle === 'lesson' && (!enrollmentInfo || !enrollmentInfo.id)) {
        info.el.classList.add('no-enrollment');
      }

      // Custom context menu.
      let eventId = info.event.id

      // Cleanup any existing tooltip for this event to prevent duplicates
      if (this.tippyEventHoverInstances.has(eventId)) {
        const existingInstance = this.tippyEventHoverInstances.get(eventId);
        if (existingInstance) {
          existingInstance.destroy();
        }
        this.tippyEventHoverInstances.delete(eventId);
      }

      info.el.addEventListener("contextmenu", (jsEvent) => {
        let bundle = info.event._def?.extendedProps?.['appointmentType'];
        if (bundle == 'lesson' || bundle == 'group_lesson' || bundle == 'services' || bundle == 'schedules') {
          jsEvent.preventDefault();
          this.copyData = info.event?._def?.extendedProps?.['eventDetails']?.data;
          this.contextMenuStandingSeriesId = info.event._def?.extendedProps?.['standingSeriesId'] || null;
          this.contextMenuEventInfo = info;

          // Custom popup box for when selecting times in the calendar.
          var left = jsEvent.pageX;
          var top = jsEvent.pageY;
          var theHeight = $("#custom-context-menu").height();
          $("#custom-context-menu").show();
          $("#custom-context-menu").css(
            "left",
            left - $("#custom-context-menu").width() / 2 + "px"
          );
          $("#custom-context-menu").css(
            "top",
            top - theHeight / 2 + 20 + "px"
          );
          $("#custom-context-menu").css("display", "block");
        }
      });

      // Get event data for tooltip content
      const eventData = info.event._def?.extendedProps?.['eventDetails']?.data;
      const tooltipBaseContent = info.event.extendedProps?.['tooltip'] || '';

      // Only create tooltip if there's content or the event has next events capability
      if (tooltipBaseContent || (eventData?.has_next_events)) {
        // Structure the tooltip content with clearly separated sections
        let tooltipContent = '<div class="tooltip-base-content">' + tooltipBaseContent + '</div>';

        // Add next events placeholder if this event has next events capability
        if (eventData?.has_next_events) {
          tooltipContent += '<div id="next-events-content" class="next-events-loading">Loading upcoming appointments...</div>';
        }

        // Add small delay to ensure element is properly positioned in DOM
        setTimeout(() => {
          // Double-check element still exists and is attached to DOM
          if (!info.el || !info.el.parentNode) {
            LoggerService.warn(`[TOOLTIP] Element no longer exists for event ${eventId}, skipping tooltip creation`);
            return;
          }

          try {
            // Create the tooltip
            const tippyInstance = tippy(info.el, {
              allowHTML: true,
              placement: "bottom",
              arrow: roundArrow,
              animation: 'fade',
              theme: 'light',
              duration: [500, 0],
              content: tooltipContent,
              // Improve positioning
              popperOptions: {
                modifiers: [
                  {
                    name: 'preventOverflow',
                    options: {
                      boundary: 'viewport',
                    },
                  },
                  {
                    name: 'flip',
                    options: {
                      fallbackPlacements: ['top', 'left', 'right'],
                    },
                  },
                ],
              },
              onShow: (instance) => {
                // Only fetch next events if this event has that capability
                if (eventData?.has_next_events) {
                  // Create a normalized cache key based on the event ID and date
                  const cacheKey = this.createNextEventsCacheKey(eventData.id, eventData.event_date);
                  LoggerService.log(`[HOVER] Tooltip onShow for event ${eventData.id}, checking cache for key ${cacheKey}`);
                  LoggerService.log(`[HOVER] Original event date: ${eventData.event_date}`);

                  // Check if data is already in cache
                  if (this.nextEventsCache.has(cacheKey)) {
                    LoggerService.log(`[HOVER] Using cached next events data for tooltip id=${eventData.id}`);
                    const cachedData = this.nextEventsCache.get(cacheKey);

                    // Get the original tooltip content without the next events section
                    const baseContent = '<div class="tooltip-base-content">' + tooltipBaseContent + '</div>';

                    // Format and add the cached content
                    const nextEventsHtml = this.formatNextEventsHtml(cachedData);
                    instance.setContent(baseContent + nextEventsHtml);
                    return;
                  }

                  // Update loading message
                  const loadingEl = document.getElementById('next-events-content');
                  if (loadingEl) {
                    loadingEl.innerHTML = '<div class="loading-spinner">Loading...</div>';
                  }

                  LoggerService.log(`[HOVER] Fetching next events for tooltip id=${eventData.id}`);
                  // Use our centralized method to load next events
                  this.loadNextEvents(
                    eventData.id,
                    eventData.event_date,
                    eventData.student_account_id || null,
                    (data: any) => {
                      LoggerService.log(`[HOVER] Received next events for tooltip id=${eventData.id}`);
                      // Get the original tooltip content without the next events section
                      const baseContent = '<div class="tooltip-base-content">' + tooltipBaseContent + '</div>';
                      // Format the next events HTML
                      const nextEventsHtml = this.formatNextEventsHtml(data);
                      // Set combined content
                      instance.setContent(baseContent + nextEventsHtml);
                    },
                    (error: any) => {
                      LoggerService.error(`[HOVER] Error fetching next events for tooltip id=${eventData.id}:`, error);
                      // Update with error message, keeping the base content
                      const baseContent = '<div class="tooltip-base-content">' + tooltipBaseContent + '</div>';
                      instance.setContent(baseContent +
                        '<div class="next-events-container"><p>Error loading upcoming appointments</p></div>');
                    }
                  );
                }
              },
              onDestroy: () => {
                // Clean up from our tracking when destroyed
                this.tippyEventHoverInstances.delete(eventId);
              }
            });

            // Store the instance for cleanup later
            if (tippyInstance) {
              this.tippyEventHoverInstances.set(eventId, tippyInstance);
            }
          } catch (error) {
            LoggerService.error(`[TOOLTIP] Error creating tooltip for event ${eventId}:`, error);
          }
        }, 10); // Small delay to ensure DOM stability
      }
    },

    customButtons: {
      goBackAWeek: {
        text: '<<',
        hint: 'Go back a week',
        click: () => {
          let calendarApi = this.calendarComponent.getApi();
          calendarApi.incrementDate({ weeks: -1 }); // Moves the calendar one week back
        }
      },
      goForwardWeek: {
        text: '>>',
        hint: 'Go forward a week',
        click: () => {
          let calendarApi = this.calendarComponent.getApi();
          calendarApi.incrementDate({ weeks: 1 }); // Moves the calendar one week forward
        }
      },
      instructorToggle: {
        text: '',
        hint: 'Filter Instructors',
        click: () => {
          // This will be handled by the Angular component
        }
      },
      studioTime: {
        text: '', // Will be updated dynamically
        hint: 'Studio Time',
        click: () => {
          // No action on click
        }
      }
    },

    headerToolbar: {
      start: 'instructorToggle,goBackAWeek,prev,today,next,goForwardWeek',
      center: 'title',
      end: 'studioTime'
    },

    viewDidMount: (arg) => {
      // Make the title clickable to open the date picker
      this.attachTitleClickHandler();
    },

    titleFormat: (date) => {
      // Use studio timezone for formatting the title
      // Use midpoint between start/end to avoid timezone boundary issues
      // This ensures we're always in the middle of the displayed day
      const midpoint = new Date((date.start.marker.getTime() + date.end.marker.getTime()) / 2);
      let newTitleFormat = moment.tz(midpoint, this.studioTimezone).format('dddd[,] MMMM DD[, ]YYYY[ - Week #]');

      // Use WeekCalculationService for correct week number (handles Week 53 logic)
      const weekNum = this.weekCalculationService.getWeekNumber(midpoint.toISOString());
      newTitleFormat += weekNum;

      // The weekNumber number
      this.weekNumber = weekNum.toString();

      return (newTitleFormat).toString();
    },

    eventClick: (info) => {
      // Tapping/clicking an event should dismiss the empty-slot booking popover.
      this.hideCustomPopover();

      // Check if we have an event with a student
      if (info.event?._def?.extendedProps?.['studentDetails']?.['studentAccountId']) {
        const studentId = info.event._def.extendedProps['studentDetails']['studentAccountId'];
        const currentDate = info.event.start;
        const currentEventId = info.event._def.extendedProps?.['entityId'];

        // Log raw date information to diagnose format issues
        LoggerService.log(`[CLICK] Raw event date: ${currentDate.toISOString()}`);

        // Create a normalized cache key using our helper method
        const cacheKey = this.createNextEventsCacheKey(currentEventId, currentDate.toISOString());

        LoggerService.log(`[CLICK] Event click for event ${currentEventId}, checking cache for key ${cacheKey}`);

        // Check if data is already in cache from tooltip hover
        if (this.nextEventsCache.has(cacheKey)) {
          LoggerService.log(`[CLICK] Using cached next events data for dialog from tooltip cache id=${currentEventId}`);
          const cachedData = this.nextEventsCache.get(cacheKey);

          // Create a copy of the info object with next events data included in extendedProps
          const enhancedInfo = {
            ...info,
            event: {
              ...info.event,
              _def: {
                ...info.event._def,
                extendedProps: {
                  ...info.event._def.extendedProps,
                  // Add upcomingEventList property using cached data
                  upcomingEventList: (cachedData && cachedData.upcomingEventList) || []
                }
              }
            }
          };

          // Open the dialog with enhanced data from cache
          this.openDialog(AppointmentDetailsComponent, "defaultWithData", enhancedInfo);
        } else {
          // If not in cache, fetch the data as before
          LoggerService.log(`[CLICK] No cache found, fetching next events for dialog id=${currentEventId}`);
          this.loadNextEvents(
            currentEventId,
            currentDate.toISOString(),
            studentId,
            (data: any) => {
              LoggerService.log(`[CLICK] Received next events for dialog id=${currentEventId}`);
              // Store in cache for potential future use
              this.nextEventsCache.set(cacheKey, data);

              // Create a copy of the info object with next events data included in extendedProps
              const enhancedInfo = {
                ...info,
                event: {
                  ...info.event,
                  _def: {
                    ...info.event._def,
                    extendedProps: {
                      ...info.event._def.extendedProps,
                      // Add upcomingEventList property without modifying the original object
                      upcomingEventList: (data && data.upcomingEventList) || []
                    }
                  }
                }
              };

              // Open the dialog with enhanced data
              this.openDialog(AppointmentDetailsComponent, "defaultWithData", enhancedInfo);
            },
            (error: any) => {
              LoggerService.error(`[CLICK] Error fetching next events data for id=${currentEventId}:`, error);

              // Even on error, provide the upcomingEventList as an empty array
              const enhancedInfo = {
                ...info,
                event: {
                  ...info.event,
                  _def: {
                    ...info.event._def,
                    extendedProps: {
                      ...info.event._def.extendedProps,
                      upcomingEventList: []
                    }
                  }
                }
              };

              // Open the dialog with the current event data plus empty upcomingEventList
              this.openDialog(AppointmentDetailsComponent, "defaultWithData", enhancedInfo);
            }
          );
        }
      } else {
        // If there's no student ID, create a copy with an empty upcomingEventList
        const enhancedInfo = {
          ...info,
          event: {
            ...info.event,
            _def: {
              ...info.event._def,
              extendedProps: {
                ...(info.event?._def?.extendedProps || {}),
                upcomingEventList: []
              }
            }
          }
        };

        // Open the dialog with the current event data
        this.openDialog(AppointmentDetailsComponent, "defaultWithData", enhancedInfo);
      }

      // hideAll() to hide all tippy instances.
      hideAll({ duration: this.tippyHideDuration });
    },

    eventMouseLeave: function (mouseLeaveInfo) {
      // hideAll() to hide all tippy instances.
      hideAll({ duration: this.tippyHideDuration });
    },

    selectable: true,
    // Lower long-press threshold so a brief touch-and-hold initiates a drag-select
    // for picking a custom duration. The single-tap path below covers the common case.
    selectLongPressDelay: 250,
    longPressDelay: 250,

    select: (info) => {
      this.showBookingPopover(info.jsEvent);

      // Get the current starting time.
      // info.start is already in the studio timezone from FullCalendar
      // We need to format it without converting to local time
      if (this.studioTimezone) {
        // Use moment-timezone to format in the studio timezone
        this.currentSelectedStartTime = moment.tz(info.start, this.studioTimezone).format('YYYY-MM-DD[T]HH:mm:ss');
      } else {
        // Fallback if studio timezone not loaded yet
        this.currentSelectedStartTime = moment(info.start).format('YYYY-MM-DD[T]HH:mm:ss');
      }

      // Calculate duration of selected area.
      this.currentSelectedDuration = this.calcDuration(info.start, info.end);

      // Grab the instructor ID, to be used to pass into the form.
      this.currentSelectedInstructorID = info.resource.id;
    },

    // When the events over loped it set false the selectable of calendar
    selectOverlap: function (event) {
      return false;
    },

    selectAllow: (date) => {
      // Find the time diff for checking the druation.
      var fromTime = date.start.getTime() / 1000;
      var toTime = date.end.getTime() / 1000;
      var timeDiff = (toTime - fromTime) / 3600; // will give difference in hrs


      var theHeight = $("#selected-hours").height();
      $("#selected-hours").css({
        "z-index": "9999",
        position: "absolute",
        display: "block",
      });

      return true;
    },

    // A single tap/click on a slot opens the booking popover with a default 45-min
    // duration. Touch users no longer need to hold-and-drag just to book.
    dateClick: (info) => {
      info.jsEvent.preventDefault();
      if (info.jsEvent.button === 2) {
        return;
      }
      if (!this._permissionsService.canAccess('lessons_edit')) {
        return;
      }

      const slotStart = info.date;
      const defaultDurationMinutes = 45;
      const slotEnd = new Date(slotStart.getTime() + defaultDurationMinutes * 60000);

      if (this.studioTimezone) {
        this.currentSelectedStartTime = moment.tz(slotStart, this.studioTimezone).format('YYYY-MM-DD[T]HH:mm:ss');
      } else {
        this.currentSelectedStartTime = moment(slotStart).format('YYYY-MM-DD[T]HH:mm:ss');
      }
      this.currentSelectedDuration = this.calcDuration(slotStart, slotEnd);
      this.currentSelectedInstructorID = info.resource?.id;

      this.showBookingPopover(info.jsEvent);
    },

    resourceLabelDidMount: (mountArg) => {
      if (mountArg.resource?.extendedProps?.['webBookings']) {
        setTimeout(() => this.tintWebBookingsColumns(), 0);
      }
      // Hover for the instructors.
      let tippyInstance = tippy(mountArg.el, {
        allowHTML: true,
        placement: "bottom",
        arrow: roundArrow,
        animation: 'fade',
        duration: [500, 0],
        theme: 'light',
        content: mountArg.resource?.extendedProps?.['info'],
      })

      this.tippyInstructorHoverInstances.set(mountArg.resource.id, tippyInstance);
    },

    // resourceLabelWillUnmount: function (unmountArg) {
    //   // Get the Tippy instance associated with the element
    //   const tippyInstance = tippy.getInstance(unmountArg.el);

    //   // If there is a Tippy instance, destroy it
    //   if (tippyInstance) {
    //     tippyInstance.destroy();
    //   }
    // },

    // Default configuration.
    slotDuration: "00:15:00",
    slotLabelInterval: "00:01:00",
    displayEventTime: false,
    slotLabelFormat: {
      hour: 'numeric',
      minute: '2-digit',
      omitZeroMinute: false,
      meridiem: 'short'
    },
  };

  updateCalendarEvents(params: any) {
    LoggerService.log('[TIMEZONE] updateCalendarEvents called with params:', params);
    LoggerService.log('[TIMEZONE] filterDateRaw:', params?.filterDateRaw);
    LoggerService.log('[TIMEZONE] filterDate:', params?.filterDate);
    LoggerService.log('[TIMEZONE] Current studio timezone:', this.studioTimezone);

    // FIX: set FullCalendar to go to the correct date.
    // Since FullCalendar is set to studio timezone, just pass the date string
    if (params.filterDateRaw) {
      LoggerService.log('[TIMEZONE] Navigating to date:', params.filterDateRaw);
      // FullCalendar will interpret this date in the studio timezone
      this.calendarComponent.getApi().gotoDate(params.filterDateRaw);
    }
    this.calendarOptions.events = this.getCalendarEvents(params);
    this.calendarOptions.resources = this.getCalendarResources(params);

    // No need to apply additional filtering since it's now handled in getCalendarResources
  }

  getCalendarEvents(params: any = null, updateColorsOnly?) {
    return (fetchInfo, successCallback, failureCallback) => {
      LoggerService.log('[TIMEZONE] getCalendarEvents called');
      LoggerService.log('[TIMEZONE] Studio timezone loaded:', this.studioTimezoneLoaded);
      LoggerService.log('[TIMEZONE] Current studio timezone:', this.studioTimezone);

      // CRITICAL: Wait for studio timezone to load before fetching events
      // This prevents events from being rendered with wrong timezone interpretation
      if (!this.studioTimezoneLoaded) {
        LoggerService.log('[TIMEZONE] Waiting for studio timezone to load, returning empty events');
        successCallback([]);
        return;
      }

      LoggerService.log('[TIMEZONE] fetchInfo:', fetchInfo);
      LoggerService.log('[TIMEZONE] fetchInfo.startStr:', fetchInfo.startStr);
      LoggerService.log('[TIMEZONE] fetchInfo.endStr:', fetchInfo.endStr);
      LoggerService.log('[TIMEZONE] fetchInfo.start:', fetchInfo.start);

      // Don't call getAMTSessionTime here - it needs filterDate to be set first

      let endpoint = "/api/dayview/calendar/events?";

      // Extract the date from the fetchInfo.startStr which is already in studio timezone
      const startDateOnly = fetchInfo.startStr.split('T')[0]; // e.g., "2025-11-01"
      const endDateOnly = fetchInfo.endStr.split('T')[0];     // e.g., "2025-11-02"

      // CRITICAL: API expects naive times (no timezone), so send dates as-is
      // The API will treat these as local studio times
      this.newDateStart = startDateOnly + 'T00:00:00';
      this.newDateEnd = endDateOnly + 'T00:00:00';
      this.calendarDateInquiry = startDateOnly + 'T12:00:00';

      // Refresh the Payments Due bell when the displayed day changes.
      if (this.paymentsDueDate !== startDateOnly) {
        this.refreshPaymentsDue(startDateOnly);
      }

      LoggerService.log('[TIMEZONE] Date extracted from fetchInfo:', startDateOnly);
      LoggerService.log('[TIMEZONE] newDateStart (naive):', this.newDateStart);
      LoggerService.log('[TIMEZONE] newDateEnd (naive):', this.newDateEnd);
      LoggerService.log('[TIMEZONE] calendarDateInquiry (naive):', this.calendarDateInquiry);
      LoggerService.log('[TIMEZONE] These are naive times representing studio local time');

      if (params) {

        if (params.filterDate) {
          LoggerService.log('[TIMEZONE] Processing filterDate in getCalendarEvents');
          LoggerService.log('[TIMEZONE] params.filterDateRaw:', params.filterDateRaw);
          // Use the raw date as naive time (API expects naive times)
          const dateForAPI = params.filterDateRaw
            ? params.filterDateRaw + 'T12:00:00'
            : this.newDateStart;
          LoggerService.log('[TIMEZONE] dateForAPI for backend (naive):', dateForAPI);
          endpoint = endpoint + "&calendar_date=" + dateForAPI;
        }

        if (params.filterStudent) {
          endpoint = endpoint + "&student=" + params.filterStudent;
        }

        if (params.filterLessonType) {
          endpoint = endpoint + "&lessonType=" + params.filterLessonType;
        }

        if (params.filterInstructorCategory) {
          endpoint = endpoint + "&instructor_category=" + params.filterInstructorCategory;

          // this.getCalendarResources(params);
        }

        if (params.filterGroupLesson) {
          endpoint = endpoint + "&group_lesson=" + params.filterGroupLesson;
        }

        if (params.filterLesson) {
          endpoint = endpoint + "&lesson=" + params.filterLesson;
        }

        if (params.filterServices) {
          endpoint = endpoint + "&services=" + params.filterServices;
        }

        if (params.filterHiddenEvents) {
          endpoint = endpoint + "&hidden_events=" + params.filterHiddenEvents;
        }

      }

      // Send start && end times.
      endpoint = endpoint + "&start=" + this.newDateStart;
      endpoint = endpoint + "&end=" + this.newDateEnd;

      // Run change on next browser MicroTask.
      Promise.resolve().then(() => {
        LoggerService.log('[TIMEZONE] Setting filterDate for UI');
        LoggerService.log('[TIMEZONE] newDateStart (naive):', this.newDateStart);

        // Parse the naive date (e.g., "2025-11-02T00:00:00") for the date picker
        // This represents the studio's local date
        const dateParts = this.newDateStart.split('T')[0].split('-');
        const year = parseInt(dateParts[0]);
        const month = parseInt(dateParts[1]) - 1; // JavaScript months are 0-indexed
        const day = parseInt(dateParts[2]);

        this.filterDate = new Date(year, month, day);
        LoggerService.log('[TIMEZONE] filterDate set to:', this.filterDate);
        LoggerService.log('[TIMEZONE] This represents:', dateParts.join('-'), '(studio local date)');

        // Now that filterDate is set, process session times
        this.getAMTSessionTime();
      })

      if (updateColorsOnly) {
        this.Events = this.fixEventColors(data);
        successCallback(data);
        return;
      }

      this._drupalRESTService.httpGET(endpoint).subscribe(data => {
        const events = data as any[]; // Cast data to an array
        if (!events || events.length === 0) {
          successCallback([]);
        } else {
          this.Events = this.fixEventColors(events);
          successCallback(events);
          setTimeout(() => this.tintWebBookingsColumns(), 0);
        }
      }, error => {
        LoggerService.error('Error fetching calendar events:', error);
        successCallback([]);
      });
    }
  }

  fixEventColors(data) {
    // LoggerService.log('Events: ', data);

    // Check if colors should change.
    for (const key in data) {
      let event = data[key];

      // Fix for events crossing day boundary (end time appears before start time)
      if (moment(event.end).isBefore(moment(event.start))) {
        // Adjust the end time to be on the next day
        let correctedEnd = moment(event.end).add(1, 'days').format();
        LoggerService.log(`Correcting event ${event.id} end time: ${event.end} -> ${correctedEnd}`);
        data[key].end = correctedEnd;
      }

      // Handle past events coloring
      if (moment(data[key].end) < moment()) {
        // LoggerService.log('event', event);
        if (event?.appointmentType == 'lesson' && event?.status != 'Showed' && event?.status !== 'Cancelled' && event?.status !== 'Rescheduled' && event?.status !== 'No Showed Not Charged') {
          // data[key].color = "#FF4136";
        }
        // // Schedules
        // if (event?.appointmentType == 'schedules' && event?.status != 'Showed' && event?.status !== 'Cancelled' && event?.status !== 'Rescheduled' && event?.status !== 'No Showed Not Charged') {
        //   data[key].color = "#474747";
        // }
        // // Services
        // if (event?.appointmentType == 'services' && event?.status != 'Showed' && event?.status !== 'Cancelled' && event?.status !== 'Rescheduled' && event?.status !== 'No Showed Not Charged') {
        //   data[key].color = "#888888";
        // }
      }

      // If event is No Show, Charged
      if (event?.status == 'No Showed, Charged') {
        data[key].color = "#626267";
      }

      // Make sure Pending Status events are displayed correctly
      if (event?.status == 'Pending Status') {
        // Ensure color is properly set for better visibility if needed
        // data[key].color = "#F2473F";
      }

      // Client-derived color wins over the server-supplied event.color.
      // Remove this line to fall back to the server-computed color.
      data[key].color = this._eventColorService.getEventColor(data[key]);
    }
    return data;
  }

  handleEventDidMount(info: any) {
    // LoggerService.log(info.event.extendedProps);
    // eventDidMount
  }

  getCalendarResources(thisParams: any = null) {
    let endpoint = "/api/dayview/calendar/resources?";

    return (fetchInfo, successCallback, failureCallback) => {
      // Check if we have the calendar API and configuration
      if (this.calendarComponent?.getApi() && this.AMTCalendarConfiguration?.['office_hours']) {
        // FIX: Use the studio timezone to get the correct day of week
        let dayOfWeek;
        if (this.studioTimezone) {
          // Parse the date in studio timezone to get the correct day
          const dateOnly = fetchInfo.startStr.split('T')[0];
          dayOfWeek = moment.tz(dateOnly, this.studioTimezone).format('dddd');
        } else {
          dayOfWeek = moment(fetchInfo.startStr).format('dddd');
        }
        LoggerService.log('[TIMEZONE] Setting office hours for day:', dayOfWeek);
        LoggerService.log('[TIMEZONE] fetchInfo.startStr:', fetchInfo.startStr);
        LoggerService.log('[TIMEZONE] Corrected day of week:', dayOfWeek);
        this.applyOfficeHoursForDay(dayOfWeek);
      }

      // Extract date-only and interpret in studio timezone for consistent week calculation
      const dateOnly = fetchInfo.startStr.split('T')[0];
      // Create a date string at noon in studio timezone to avoid any day boundary issues
      const dateForWeekCalc = moment.tz(dateOnly + ' 12:00', this.studioTimezone).toISOString();

      let params = [
        { parameter: 'start', value: fetchInfo.startStr },
        { parameter: 'end', value: fetchInfo.endStr },
        // Using custom week calculation to handle Week 53 logic correctly
        { parameter: 'week', value: this.weekCalculationService.getWeekNumber(dateForWeekCalc) },
        // Using custom year calculation to handle year boundary cases correctly
        // Standard moment().isoWeekYear() doesn't work because our weeks start on Sunday
        // while ISO weeks start on Monday, causing issues at year boundaries
        { parameter: 'year', value: this.weekCalculationService.getCorrectYearForWeek(dateForWeekCalc) },
      ];

      if (thisParams?.filterInstructorCategory) {
        params = [
          ...params,
          { parameter: 'instructor_category', value: thisParams.filterInstructorCategory },
        ];
      }

      this._drupalRESTService.httpGET(endpoint, params)
        .subscribe(data => {
          this.calcSummary(data);

          // Store all resources for filtering
          if (Array.isArray(data)) {
            this.allResources = [...data];

            // Update resources array for instructor toggle
            const newResourceIds = data.map(resource => resource.id).sort().join(',');
            const currentResourceIds = this.resourcesArray.map(resource => resource.id).sort().join(',');

            if (newResourceIds !== currentResourceIds) {
              this.resourcesArray = data.map(resource => ({
                id: resource.id,
                title: resource.title,
                // The Website Booking tray is shown whatever the stored
                // column selection says: it only exists on days that need it.
                pinned: !!resource.webBookings,
              }));
            }

            // Apply instructor filtering before rendering to prevent flash
            let filteredData = data;
            if (this.filterInstructor && this.filterInstructor.length > 0) {
              filteredData = data.filter(resource =>
                this.filterInstructor.includes(resource.id) || resource.webBookings
              );
            }

            // Track currently visible resources
            this.currentlyVisibleResources = new Set(filteredData.map(resource => resource.id));

            // Return filtered data to prevent flash of all instructors
            successCallback(filteredData);
          } else {
            successCallback(data);
          }

          // Update the instructor hover info.
          this.tippyInstructorHoverInstances.forEach((tippyInstance, resourceId) => {
            if (this.calendarComponent && this.calendarComponent.getApi()) {
              const resource = this.calendarComponent.getApi().getResourceById(resourceId);
              if (resource) {
                tippyInstance.setContent(resource.extendedProps['info']);
              }
            }
          });
        },
          error => this.handleError(error)
        );
    };
  }

  calcSummary(data) {
    LoggerService.log("calcSummary called...", data)
    let alreadyCounted: number[] = [];

    // Reset Summary
    this.summaryCount = {
      privateLessonDaily: 0,
      privateLessonWeekly: 0,
      privateTakenLessonDaily: 0,
      privateTakenLessonWeekly: 0,
    }

    // Aggregate the per-category breakdown across all instructors, preserving
    // the backend's category order. Keyed by category key while summing.
    const categoryOrder: string[] = [];
    const categoryMap: { [key: string]: any } = {};

    data.forEach((element: {
      id: string;
      privateLesson: number[];
      privatePostedLesson: number[];
      categoryBreakdown?: any[];
    }) => {
      let id = parseInt(element.id)

      if (alreadyCounted.includes(id)) { } else {
        this.summaryCount.privateLessonWeekly += element.privateLesson[1];
        this.summaryCount.privateLessonDaily += element.privateLesson[0];
        this.summaryCount.privateTakenLessonWeekly += element.privatePostedLesson[1];
        this.summaryCount.privateTakenLessonDaily += element.privatePostedLesson[0];

        (element.categoryBreakdown || []).forEach((row: any) => {
          if (!categoryMap[row.key]) {
            categoryMap[row.key] = {
              key: row.key,
              label: row.label,
              bookedDaily: 0, takenDaily: 0, bookedWeekly: 0, takenWeekly: 0,
            };
            categoryOrder.push(row.key);
          }
          categoryMap[row.key].bookedDaily += row.bookedDaily || 0;
          categoryMap[row.key].takenDaily += row.takenDaily || 0;
          categoryMap[row.key].bookedWeekly += row.bookedWeekly || 0;
          categoryMap[row.key].takenWeekly += row.takenWeekly || 0;
        });

        alreadyCounted.push(id);
      };
    });

    this.summaryBreakdown = categoryOrder.map(key => categoryMap[key]);

    // Coaching gets its own header fraction: pull its bucket totals and remove
    // them from the main Overall Summary numbers so the two don't overlap.
    const coaching = categoryMap['coaching'];
    this.summaryCoaching = {
      bookedDaily: coaching?.bookedDaily || 0,
      takenDaily: coaching?.takenDaily || 0,
      bookedWeekly: coaching?.bookedWeekly || 0,
      takenWeekly: coaching?.takenWeekly || 0,
    };
    this.summaryCount.privateLessonDaily -= this.summaryCoaching.bookedDaily;
    this.summaryCount.privateLessonWeekly -= this.summaryCoaching.bookedWeekly;
    this.summaryCount.privateTakenLessonDaily -= this.summaryCoaching.takenDaily;
    this.summaryCount.privateTakenLessonWeekly -= this.summaryCoaching.takenWeekly;

    // Non Unit lesson types (Non Unit=1405, Non Unit Group=1410,
    // Non Unit Private=1411) also stay out of the main Overall Summary
    // numbers. They remain visible as their own dropdown rows. Coaching
    // lessons are already in the 'coaching' bucket (subtracted above), so
    // these buckets only hold the remaining non-coaching Non Units.
    const nonUnitKeys = ['type_1405', 'type_1410', 'type_1411'];
    nonUnitKeys.forEach(key => {
      const bucket = categoryMap[key];
      if (bucket) {
        this.summaryCount.privateLessonDaily -= bucket.bookedDaily;
        this.summaryCount.privateLessonWeekly -= bucket.bookedWeekly;
        this.summaryCount.privateTakenLessonDaily -= bucket.takenDaily;
        this.summaryCount.privateTakenLessonWeekly -= bucket.takenWeekly;
      }
    });
  }

  // Get the session time.
  private sessionTimeInFlight: boolean = false;
  getAMTSessionTime(forceRefresh: boolean = false) {
    // Only fetch if we don't already have the data or if force refresh is requested
    if (this.AMTSessionTime && !forceRefresh) {
      // Data already loaded, just process it
      this.processAMTSessionTime();
      return;
    }

    // A request is already in flight. The existing subscription will populate the cache
    // and run processAMTSessionTime when it resolves, so don't start a duplicate request.
    if (this.sessionTimeInFlight) {
      return;
    }

    let endpoint = "/api/dayview/calendar/configurations-session";
    this.sessionTimeInFlight = true;
    this._drupalRESTService.httpGET(endpoint)
      .subscribe({
        next: (data) => {
          this.AMTSessionTime = data;
          this.processAMTSessionTime();
        },
        complete: () => { this.sessionTimeInFlight = false; },
        error: () => { this.sessionTimeInFlight = false; }
      });
  }

  // Clear cached session time data (useful when configuration might have changed)
  clearSessionTimeCache() {
    this.AMTSessionTime = null;
  }

  // Load configuration sessions from Drupal.
  processAMTSessionTime() {
    let dataObject = this.AMTSessionTime;

    // Only process session times if we have both filterDate and studioTimezone
    if (!this.filterDate || !this.studioTimezone) {
      LoggerService.log('[SESSION] Cannot process session times - missing required data');
      LoggerService.log('[SESSION] filterDate:', this.filterDate);
      LoggerService.log('[SESSION] studioTimezone:', this.studioTimezone);
      return;
    }

    // Calculate the day name from the date being displayed
    // Use the date string directly to avoid timezone conversion issues
    const dateStr = moment(this.filterDate).format('YYYY-MM-DD');
    const dayName = moment(dateStr).format('dddd').toLowerCase();
    LoggerService.log('[SESSION] Calculated day name:', dayName, 'from date:', dateStr);

    // Strip the gray colors - clear ALL time slot elements to prevent residue
    // Clear both slot lanes and individual time slots
    $('.fc-timegrid-slot-lane').css(
      "background",
      ""  // Use empty string instead of "none" to allow CSS to take over
    );
    // Also clear all time slots with data-time attributes to remove any previous day's gray backgrounds
    $('.fc-timegrid-slot').css(
      "background",
      ""
    );

    // Check if the day exists in dataObject and apply styles
    if (dataObject[dayName]) {
      dataObject[dayName].forEach(function (item) {
        // Target time slots more specifically
        $('.fc-timegrid-slot[data-time="' + item + '"]').css(
          "background",
          "#ccc"
        );
      });
    }

    // Log session time processing for debugging
    LoggerService.log('[SESSION] Processing session times for day:', dayName);
    LoggerService.log('[SESSION] Using filterDate:', this.filterDate);
    LoggerService.log('[SESSION] filterDate as date:', this.filterDate ? moment(this.filterDate).format('YYYY-MM-DD dddd') : 'not set');
    LoggerService.log('[SESSION] Studio timezone:', this.studioTimezone);
    LoggerService.log('[SESSION] newDateStart:', this.newDateStart);
    if (dataObject[dayName]) {
      LoggerService.log('[SESSION] Applying gray times for', dayName + ':', dataObject[dayName]);
    } else {
      LoggerService.log('[SESSION] No gray times configured for', dayName);
    }
  }

  /**
   * Fits the time grid to the studio's hours for the displayed day. A closed
   * day (no hours stored) uses the widest open range instead of keeping the
   * previous day's.
   */
  private applyOfficeHoursForDay(dayName: string): void {
    const officeHours = this.AMTCalendarConfiguration?.['office_hours'];
    if (!officeHours?.minTime) {
      // No working hours configured: leave the range alone.
      return;
    }
    const dayHours = officeHours[dayName];

    const api = this.calendarComponent?.getApi();
    const start = dayHours?.start || officeHours.minTime;
    const end = dayHours?.end || officeHours.maxTime;
    if (api && (api.getOption('slotMinTime') !== start || api.getOption('slotMaxTime') !== end)) {
      api.setOption('slotMinTime', start);
      api.setOption('slotMaxTime', end);
    }
  }

  /** Weekday name of the date on screen, in the studio's timezone. */
  private displayedDayName(): string {
    const date = this.calendarComponent?.getApi()?.getDate() ?? new Date();
    return this.studioTimezone ? moment.tz(date, this.studioTimezone).format('dddd') : moment(date).format('dddd');
  }

  getAMTCalendarConfiguration() {
    let endpoint = "/api/dayview/calendar/settings";

    this._drupalRESTService.httpGET(endpoint)
      .subscribe({
        next: (data) => {
          this.AMTCalendarConfiguration = data;

          // Office hours for the day on screen (widest open range when closed)
          const currentDay = this.displayedDayName();
          const daySpecificHours = this.AMTCalendarConfiguration['office_hours'][currentDay];

          LoggerService.log('[TIMEZONE] Initial calendar configuration:');
          LoggerService.log('[TIMEZONE] Current day for initial config:', currentDay);
          LoggerService.log('[TIMEZONE] Day-specific hours:', daySpecificHours);
          LoggerService.log('[TIMEZONE] Default office hours:', data['office_hours']);

          // Apply the studio's 12/24-hour preference to axis labels and event times.
          const timeFmt = getCalendarTimeFormat(data['time_format']);

          this.calendarOptions = {
            ...this.calendarOptions,
            slotDuration: data['duration'],
            nowIndicator: true,
            slotLabelInterval: data['slot_interval'],
            displayEventTime: data['event_time'],
            resourceOrder: 'order_id',
            slotLabelFormat: timeFmt.slotLabelFormat,
            eventTimeFormat: timeFmt.eventTimeFormat,
            // Set initial time range based on current day
            slotMinTime: daySpecificHours?.start || data['office_hours']['minTime'],
            slotMaxTime: daySpecificHours?.end || data['office_hours']['maxTime'],
            // Shades closed days; open days fill the grid, so they show no shading.
            businessHours: buildOfficeBusinessHours(data['office_hours'])
          };
          this.applyOfficeHoursForDay(currentDay);

          LoggerService.log('[TIMEZONE] Initial slotMinTime:', this.calendarOptions.slotMinTime);
          LoggerService.log('[TIMEZONE] Initial slotMaxTime:', this.calendarOptions.slotMaxTime);
        },
        error: (error) => {
          LoggerService.error('Error loading calendar configuration:', error);
          // Handle error appropriately
        }
      });
  }

  getAMTFilterConfiguration() {
    let endpoint = "/api/dayview/calendar/filterInit";

    this._drupalRESTService.httpGET(endpoint)
      .subscribe(data => {
        this.filterLessonType = data['lessonTypes'];

        this.filterInstructorCategory = data['teacherCategory'];
        // Note: filterInstructor is managed by the instructor toggle component
        // Do not overwrite it here - it contains individual instructor IDs, not categories
      });
  }

  getInstructorList() {
    let endpoint = "/api_rest/v1/teacherList";

    this._drupalRESTService.httpGET(endpoint)
      .subscribe(data => {
        this.InstructorList = data;
      })
  }

  getAMTAutocomplete() {
    let endpoint = "/api_rest/v1/autocomplete?";

    this._drupalRESTService.httpGET(endpoint)
      .subscribe(data => {
        this.AMTConfiguration = data;
      });
  }

  getAMTDayView() {
    let endpoint = "/api/dayview/resource?instructor_category=78&instructor=&lessonType=&student=&calendar_date=&start=2021-12-01T00%3A00%3A00&end=2021-12-02T00%3A00%3A00&_=1638394993251";

    this._drupalRESTService.httpGET(endpoint)
      .subscribe(data => {
        this.AMTDayView = data;
      });
  }

  override handleError(error: any) {
    // LoggerService.log("error", error);


    // Handle authentication errors.
    if (error.status == 302) {
      // this.errorMessage = error.error.message;
      // LoggerService.log('this means user logged in')
    }

    // Handle authentication errors.
    if (error.status == 403 || error.status == 400) {

      // TODO: this should save state

      // User needs to login.
      this._authService.set_user_authenticated(false);
      this._router.navigate(['/auth/login'], { queryParams: { logged_out_inactive: true } })
    }
  }

  calcDuration(dateStart: moment.MomentInput, dateEnd: moment.MomentInput) {
    let startDate = moment(dateStart);
    let endDate = moment(dateEnd);
    let duration = moment.duration(endDate.diff(startDate));

    let MINUTES = duration.asMinutes();
    let m = duration.asMinutes() % 60;
    let h = (MINUTES - m) / 60;
    let HHMM = (h < 10 ? "0" : "") + h.toString() + ":" + (m < 10 ? "0" : "") + m.toString();

    return HHMM
  }

  toggleEventConfirmation(event) {
    LoggerService.log('event', event);

    // Confirmation status for events.
    let isConfirmed = event.event._def.extendedProps?.['eventDetails']?.data?.isConfirmed;
    let eventID = event.event._def.extendedProps?.['entityId'];

    // Update the data in the event object
    event.event._def.extendedProps['eventDetails'].data.isConfirmed = !isConfirmed;

    // Force FullCalendar to re-render this specific event immediately
    if (this.calendarComponent?.getApi()) {
      const fcEvent = this.calendarComponent.getApi().getEventById(event.event.id);
      if (fcEvent) {
        // Use setExtendedProp to update specific extended prop
        fcEvent.setExtendedProp('eventDetails', { ...event.event._def.extendedProps.eventDetails });
        // Set a special flag to force a full rerender
        fcEvent.setExtendedProp('_forceRerender', Date.now());
      }
    }

    let body = {
      field_is_confirmed: !isConfirmed,
    }

    this._entityRESTService.patchEntity('events', 'lesson', eventID, body).subscribe({
      next: (data) => {
        // Show snackbar message based on new confirmation status
        if (!isConfirmed) {
          this.showSnackbar('Thank you for confirming this lesson.');
        } else {
          this.showSnackbar('Lesson confirmation has been removed.');
        }
      },
      error: (error) => {
        // In case of error, revert the UI change
        LoggerService.error('Error updating confirmation status:', error);

        // Revert the data change
        event.event._def.extendedProps['eventDetails'].data.isConfirmed = isConfirmed;

        // Force a re-render again to show the reverted state
        if (this.calendarComponent?.getApi()) {
          const fcEvent = this.calendarComponent.getApi().getEventById(event.event.id);
          if (fcEvent) {
            fcEvent.setExtendedProp('eventDetails', { ...event.event._def.extendedProps.eventDetails });
            fcEvent.setExtendedProp('_forceRerender', Date.now());
          }
        }

        this.showSnackbar('Failed to update confirmation status. Please try again.');
      }
    });
  }

  isEventHidden(): boolean {
    return this.copyData?.['field_exclude_from_display'] == 1;
  }

  hideClick() {
    this.toggleEventVisibility(true);
  }

  unhideClick() {
    this.toggleEventVisibility(false);
  }

  toggleEventVisibility(hide: boolean) {
    $("#custom-context-menu").hide();

    const bundle = this.copyData?.['bundle'];
    const entityType = 'events';
    const eventId = this.copyData?.['id'];

    if (!bundle || !eventId) {
      LoggerService.error('No event selected or missing bundle/id');
      return;
    }

    const patchData = {
      field_exclude_from_display: [{ value: hide }]
    };

    this._entityRESTService.patchEntity(entityType, bundle, eventId, patchData)
      .subscribe(
        response => {
          LoggerService.log(`Event ${hide ? 'hidden' : 'unhidden'} successfully`, response);
          this.refreshCalendar();
        },
        error => {
          LoggerService.error(`Error ${hide ? 'hiding' : 'unhiding'} event`, error);
          if (this._snackBar) {
            this._snackBar.open(`Failed to ${hide ? 'hide' : 'unhide'} event. Please try again.`, 'Close', {
              duration: 3000,
            });
          }
        }
      );
  }

  copyClick() {
    $("#custom-context-menu").hide();

    const bundle = this.copyData?.['bundle'];
    const entityType = 'events';
    let componentType: ComponentType<unknown>;
    let fieldsData: any = {};
    const ensureArray = (value: any) => Array.isArray(value) ? value : (value ? [value] : []);

    this._entityRESTService.getEntity(entityType, bundle, this.copyData?.['id']).subscribe(data => {
      switch (bundle) {
        case 'lesson':
          componentType = EventLessonEntityComponent;
          fieldsData = {
            'field_type': data?.['field_type'],
            'field_instructor': data?.['field_instructor']?.['id'],
            'field_duration': this.copyData?.['eventDuration'],
            'field_date_and_time': data?.['field_date_and_time'],
            'field_student': [{
              'type': 'attendees',
              'bundle': 'attendance',
              'title': data?.['field_student']?.['title'],
              'field_description': data?.['field_student']?.['field_description'],
              'field_enrollment': data?.['field_student']?.['field_enrollment'],
              'field_status': '64', // Pending status
              'field_students': data?.['field_student']?.['field_students'],
              'field_student_account': (data?.['field_student']?.['title'] + ' (' + data?.['field_student']?.['field_student_account'] + ')'),
            }]
          };
          break;
        case 'services':
          componentType = EventServicesEntityComponent;
          fieldsData = {
            'field_type': data?.['field_type'],
            'field_executive': data?.['field_executive']?.['id'],
            'field_duration': this.copyData?.['eventDuration'],
            'field_date_and_time': data?.['field_date_and_time'],
            'field_notes': data?.['field_notes'],
            'field_student': [{
              'type': 'attendees',
              'bundle': 'attendance',
              'field_student_account': data?.['field_student']?.['field_student_account']
                ? `${data?.['field_student']?.['title']} (${data?.['field_student']?.['field_student_account']})`
                : undefined,
              'field_students': data?.['field_student']?.['field_students'],
            }]
          };
          break;
        case 'group_lesson':
          componentType = EventGroupLessonEntityComponent;
          fieldsData = {
            'field_type': data?.['field_type'],
            'field_instructor': ensureArray(data?.['field_instructor']?.['id']),
            'field_duration': this.copyData?.['eventDuration'],
            'field_date_and_time': data?.['field_date_and_time'],
            'field_students': ensureArray(data?.['field_students']).map(student => this.prepareStudentData(student))
          };
          break;
        case 'schedules':
          componentType = EventSchedulesEntityComponent;
          fieldsData = {
            'field_type': data?.['field_type'],
            'field_duration': this.copyData?.['eventDuration'],
            'field_date_and_time': data?.['field_date_and_time'],
            'field_schedule_instructor': [data?.['field_schedule_instructor']?.['id']],
          };
          break;
        default:
          LoggerService.error('Unsupported bundle type:', bundle);
          return;
      }

      this._dialogService.openDialog(componentType, "defaultLargeWithData", {
        data: {
          EntityID: null,
          eckType: entityType,
          bundle: bundle,
          action: 'create',
          fieldsData: fieldsData,
        },
      }).afterClosed().subscribe(data => {
        this.refreshCalendar();
      });
    });
  }

  private prepareStudentData(studentData: any): any {
    if (!studentData) return null;

    return {
      'type': 'attendees',
      'bundle': 'attendance',
      'title': studentData?.['title'],
      'field_description': studentData?.['field_description'],
      'field_enrollment': studentData?.['field_enrollment'],
      'field_status': '64', // Pending status
      'field_students': studentData?.['field_students'],
      'field_student_account': `${studentData?.['title']} (${studentData?.['field_student_account']})`,
    };
  }

  pasteClick() {
    LoggerService.log('paste click');
  }

  closeContextMenu() {
    $("#custom-context-menu").hide();
  }

  // Outlook-style context menu actions for standing series events

  openThisEvent() {
    $("#custom-context-menu").hide();
    if (this.contextMenuEventInfo) {
      // Reuse the existing eventClick handler (same as left-click)
      if (this.calendarOptions?.eventClick) {
        (this.calendarOptions.eventClick as any)(this.contextMenuEventInfo);
      }
    }
  }

  openSeriesDialog(initialAction: 'view' | 'edit' = 'view') {
    $("#custom-context-menu").hide();
    if (!this.contextMenuStandingSeriesId) return;

    this._dialogService.openDialog(StandingSeriesDialogComponent, 'defaultLargeWithData', {
      standingSeriesId: this.contextMenuStandingSeriesId,
      studentAccountId: this.copyData?.['student_account_id'] || '',
      entityId: this.copyData?.['id'] || '',
      initialAction: initialAction,
    }).afterClosed().subscribe(() => {
      this.refreshCalendar();
    });
  }

  deleteThisEvent() {
    $("#custom-context-menu").hide();
    if (!this.contextMenuStandingSeriesId) return;

    this._dialogService.openDialog(StandingSeriesDialogComponent, 'defaultLargeWithData', {
      standingSeriesId: this.contextMenuStandingSeriesId,
      studentAccountId: this.copyData?.['student_account_id'] || '',
      entityId: this.copyData?.['id'] || '',
      initialAction: 'deleteSingle',
    }).afterClosed().subscribe(() => {
      this.refreshCalendar();
    });
  }

  deleteSeriesDialog() {
    $("#custom-context-menu").hide();
    if (!this.contextMenuStandingSeriesId) return;

    this._dialogService.openDialog(StandingSeriesDialogComponent, 'defaultLargeWithData', {
      standingSeriesId: this.contextMenuStandingSeriesId,
      studentAccountId: this.copyData?.['student_account_id'] || '',
      entityId: this.copyData?.['id'] || '',
      initialAction: 'deleteSeries',
    }).afterClosed().subscribe(() => {
      this.refreshCalendar();
    });
  }

  hideCustomPopover() {
    if (this.customPopover?.nativeElement) {
      this.customPopover.nativeElement.style.display = 'none';
    } else {
      $("#custom-popover").hide();
    }
    this.detachPopoverDismissListener();
  }

  // "Coaching" booking options (slot popover + New Event menu): one entry per
  // studio Coaching package. Refreshed each time a menu opens; the previous
  // list stays visible meanwhile.
  coachingPackages: { id: string, name: string }[] = [];
  coachingPackagesLoading = false;
  bookingMenuOpenKey = 0;

  /** Booking menu option picked for the clicked slot. */
  onBookingMenuChoice(choice: BookingMenuChoice): void {
    const slot = {
      'field_duration': this.currentSelectedDuration,
      'field_date_and_time': this.currentSelectedStartTime,
    };
    switch (choice) {
      case 'lesson':
        this.openEntityComponent(EventLessonEntityComponent, 'events', 'lessons', 'create', '', { 'field_instructor': this.currentSelectedInstructorID, ...slot });
        break;
      case 'service':
        this.openEntityComponent(EventServicesEntityComponent, 'events', 'services', 'create', '', { 'field_executive': this.currentSelectedInstructorID, ...slot });
        break;
      case 'schedule':
        this.openEntityComponent(EventSchedulesEntityComponent, 'events', 'schedules', 'create', '', { 'field_schedule_instructor': [this.currentSelectedInstructorID], ...slot });
        break;
      case 'group_lesson':
        this.openEntityComponent(EventGroupLessonEntityComponent, 'events', 'group_lesson', 'create', '', { 'field_instructor': [this.currentSelectedInstructorID], ...slot });
        break;
      case 'inquiry':
        this.openEntityComponent(StudentInquiryEntityComponent, 'student_accounts', 'student_account', 'create', '', {
          'dayview_field_date_and_time': this.currentSelectedStartTime || this.calendarDateInquiry,
          'field_teacher': this.currentSelectedInstructorID,
          'inquiry': true
        });
        break;
    }
    this.hideCustomPopover();
  }

  loadCoachingPackages(): void {
    this.coachingPackagesLoading = this.coachingPackages.length === 0;
    this._packagesService.getCoachingPackages().subscribe(packages => {
      this.coachingPackages = packages;
      this.coachingPackagesLoading = false;
    });
  }

  /**
   * Open the Lesson form as Non Unit Private, limited to one Coaching package's
   * enrollments. fromSlot carries over the clicked booking-sheet slot.
   */
  openCoachingLesson(coachingPackage: { id: string, name: string }, fromSlot: boolean): void {
    const fieldsData: any = {
      'field_type': '1411',
      '__coaching_package': coachingPackage,
    };
    if (fromSlot) {
      fieldsData['field_instructor'] = this.currentSelectedInstructorID;
      fieldsData['field_duration'] = this.currentSelectedDuration;
      fieldsData['field_date_and_time'] = this.currentSelectedStartTime;
    }
    this.openEntityComponent(EventLessonEntityComponent, 'events', 'lessons', 'create', '', fieldsData);
  }

  private popoverDismissListener: ((ev: PointerEvent) => void) | null = null;

  private attachPopoverDismissListener(): void {
    this.detachPopoverDismissListener();
    setTimeout(() => {
      const handler = (ev: PointerEvent) => {
        const popover = document.getElementById('custom-popover');
        if (!popover) return;
        if (ev.target instanceof Node && popover.contains(ev.target)) {
          return;
        }
        this.hideCustomPopover();
      };
      this.popoverDismissListener = handler;
      document.addEventListener('pointerdown', handler, true);
    }, 0);
  }

  private detachPopoverDismissListener(): void {
    if (this.popoverDismissListener) {
      document.removeEventListener('pointerdown', this.popoverDismissListener, true);
      this.popoverDismissListener = null;
    }
  }

  /**
   * Position and show the booking popover near the tapped/selected slot.
   * Used by both the touch tap path (dateClick) and the drag-select path (select).
   */
  private showBookingPopover(jsEvent: MouseEvent | TouchEvent | any): void {
    const popover = $("#custom-popover");
    if (!popover.length) {
      return;
    }

    let pageX: number = jsEvent?.pageX;
    let pageY: number = jsEvent?.pageY;
    if ((pageX === undefined || pageY === undefined) && jsEvent?.changedTouches?.length) {
      pageX = jsEvent.changedTouches[0].pageX;
      pageY = jsEvent.changedTouches[0].pageY;
    }
    if ((pageX === undefined || pageY === undefined) && jsEvent?.touches?.length) {
      pageX = jsEvent.touches[0].pageX;
      pageY = jsEvent.touches[0].pageY;
    }

    popover.css("display", "block").show();
    const popoverWidth = popover.outerWidth() || 0;
    const popoverHeight = popover.outerHeight() || 0;

    const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const scrollX = window.scrollX || window.pageXOffset || 0;
    const scrollY = window.scrollY || window.pageYOffset || 0;

    let left = (pageX ?? scrollX + viewportWidth / 2) - popoverWidth / 2;
    let top = (pageY ?? scrollY + viewportHeight / 2) + 10;

    const minLeft = scrollX + 8;
    const maxLeft = scrollX + viewportWidth - popoverWidth - 8;
    if (left < minLeft) left = minLeft;
    if (left > maxLeft) left = Math.max(minLeft, maxLeft);

    const minTop = scrollY + 8;
    const maxTop = scrollY + viewportHeight - popoverHeight - 8;
    if (top > maxTop && pageY !== undefined) {
      top = pageY - popoverHeight - 10;
    }
    if (top < minTop) top = minTop;

    popover.css({ left: left + "px", top: top + "px" });
    this.attachPopoverDismissListener();
    this.bookingMenuOpenKey++;
    this.loadCoachingPackages();
  }

  /**
   * Open print attendance dialog
   */
  // "Payments" notification bell: every appointment on the displayed day
  // with its student's payment status (Unpaid / Paid / Covered) and amounts,
  // from /api/payments-due-report/day, same rules as the Payments Due
  // reports.
  showPaymentsDueBell = true;
  paymentsDueAppointments: any[] = [];
  paymentsDueTotals: any = { due_today: 0, unpaid: 0, past_due: 0, due_today_tax: 0, unpaid_tax: 0, past_due_tax: 0 };
  paymentsDueLoading = false;
  paymentsDueDate = '';
  // Exclusive-tax studio (tax added on top of prices): the bell shows amounts
  // incl. tax (what the customer actually hands over) with the tax broken
  // out under the totals. Same convention as the dashboard/enrollment list.
  paymentsDueShowTax = false;
  private paymentsDueTaxSubscribed = false;

  get paymentsDueUnpaidCount(): number {
    return this.paymentsDueAppointments.filter(a => a.status === 'Unpaid').length;
  }

  /** Row/total amount as displayed: incl. tax for exclusive-tax studios. */
  paymentsDueWithTax(amount: any, tax: any): number {
    const base = parseFloat(amount) || 0;
    return this.paymentsDueShowTax ? Math.round((base + (parseFloat(tax) || 0)) * 100) / 100 : base;
  }

  refreshPaymentsDue(date: string): void {
    // payments_view ("View payments"): the menu exposes per-student amounts,
    // so it follows the payment-records permission, not reports.
    if (!this.showPaymentsDueBell || !date || !this._permissionsService.canAccess('payments_view')) {
      return;
    }
    if (!this.paymentsDueTaxSubscribed) {
      this.paymentsDueTaxSubscribed = true;
      this.paymentsDueTaxSubscription = this._studioTaxService.getTaxMode().subscribe(mode => {
        this.paymentsDueShowTax = mode.hasExclusiveTax;
      });
    }
    this.paymentsDueDate = date;
    this.paymentsDueLoading = true;
    this._drupalRESTService.httpGET('/api/payments-due-report/day', [{ parameter: 'date', value: date }])
      .subscribe({
        next: (response: any) => {
          // A stale response for a day we've already navigated away from
          // must not overwrite the current day's rows.
          if (response?.date && response.date !== this.paymentsDueDate) {
            return;
          }
          this.paymentsDueAppointments = response?.appointments ?? [];
          this.paymentsDueTotals = response?.totals ?? { due_today: 0, unpaid: 0, past_due: 0 };
          this.paymentsDueLoading = false;
        },
        error: () => {
          this.paymentsDueAppointments = [];
          this.paymentsDueTotals = { due_today: 0, unpaid: 0, past_due: 0 };
          this.paymentsDueLoading = false;
        },
      });
  }

  goToPaymentsDueStudent(row: any): void {
    // Student dashboard dialog, same as students-list and week view. Its
    // student_id param is actually the CONTACT id (loadStudentDashboard is
    // keyed by contact), so an account with no contact has no dashboard.
    if (row.contact_id) {
      this._dialogService.openDialog(StudentDashboardWrapperComponent, 'largerScreenDashboard', { student_id: row.contact_id });
    }
  }

  openPrintDialog(): void {
    LoggerService.log('Opening print dialog with:');
    LoggerService.log('Events:', this.Events);
    LoggerService.log('Resources:', this.Resources);
    LoggerService.log('Current date:', this.filterDate);

    // Close any existing print dialogs to prevent duplicates
    this._dialogService.closeAll();

    // Get resources from FullCalendar API if Resources is empty
    let resources = this.Resources;
    if (this.calendarComponent && this.calendarComponent.getApi()) {
      const calendarResources = this.calendarComponent.getApi().getResources();
      if (calendarResources && calendarResources.length > 0) {
        resources = calendarResources.map(resource => ({
          id: resource.id,
          title: resource.title,
          name: resource.title,
          display_name: resource.title,
          ...resource.extendedProps
        }));
        LoggerService.log('Using calendar resources:', resources);
      }
    }

    const dialogRef = this._dialogService.openDialog(PrintAttendanceComponent, "largerScreenDashboard", {
      data: {
        events: this.Events,
        resources: resources,
        currentDate: this.filterDate
      }
    });

    // Ensure proper cleanup when dialog closes
    dialogRef.afterClosed().subscribe(() => {
      LoggerService.log('Print dialog closed');
      // Additional cleanup if needed
      const leftoverContainers = document.querySelectorAll('.print-attendance-container');
      if (leftoverContainers.length > 0) {
        LoggerService.log('Cleaning up leftover containers:', leftoverContainers.length);
        leftoverContainers.forEach(container => container.remove());
      }
    });
  }

  // Override the refreshCalendar method from BaseComponent to prevent refreshes during drag operations
  override refreshCalendar(refresh = 0) {
    // Skip refresh if currently dragging
    if (this.isDragging) {
      return;
    }

    // Clear the next events cache when refreshing
    this.nextEventsCache.clear();

    // Clean up all existing event tooltip instances before refresh
    this.cleanupEventTooltips();

    // Perform the refresh - no need to call gotoDate since refetch keeps the current date
    // and calling gotoDate would trigger an extra fetch due to refetchResourcesOnNavigate: true
    setTimeout(() => {
      if (this?.calendarComponent?.getApi()) {
        this.calendarComponent.getApi().refetchEvents();
        this.calendarComponent.getApi().refetchResources();
      }
    }, refresh);
  }

  /**
   * Refreshes the calendar while preserving the current date.
   * This method is called when refresh is triggered from menu actions.
   * Note: refetchEvents/refetchResources automatically preserve the current date,
   * so no need to call gotoDate (which would cause extra fetches due to refetchResourcesOnNavigate).
   */
  private refreshCalendarWithDatePreservation(): void {
    if (!this.calendarComponent?.getApi()) {
      LoggerService.warn('Calendar API not available for refresh');
      return;
    }

    // Clear the next events cache when refreshing
    this.nextEventsCache.clear();

    // Clean up all existing event tooltip instances before refresh
    this.cleanupEventTooltips();

    // Refresh events and resources - these preserve the current date automatically
    this.calendarComponent.getApi().refetchEvents();
    this.calendarComponent.getApi().refetchResources();
  }

  /**
   * Clean up all event tooltip instances
   */
  private cleanupEventTooltips(): void {
    LoggerService.log(`[TOOLTIP] Cleaning up ${this.tippyEventHoverInstances.size} event tooltip instances`);

    this.tippyEventHoverInstances.forEach((instance, eventId) => {
      try {
        if (instance && typeof instance.destroy === 'function') {
          instance.destroy();
        }
      } catch (error) {
        LoggerService.error(`[TOOLTIP] Error destroying tooltip instance for event ${eventId}:`, error);
      }
    });

    this.tippyEventHoverInstances.clear();
  }

  /**
   * Format next events data into HTML
   *
   * @param nextEvents The next events data from the API
   * @returns Formatted HTML string
   */
  /** Escapes a value before it is interpolated into HTML assigned to innerHTML. */
  /**
   * Tints the body of the Website Booking column to match its header. The
   * time-grid lane cells carry data-resource-id but offer no class hook, so
   * they are marked after each resources/events render.
   */
  private tintWebBookingsColumns(): void {
    this.allResources.filter((r: any) => r?.webBookings).forEach((r: any) => {
      document
        .querySelectorAll(`.fc-timegrid-col[data-resource-id="${r.id}"], .fc-col-header-cell[data-resource-id="${r.id}"]`)
        .forEach(el => el.classList.add('bg-warning-subtle'));
    });
  }

  private escapeHtml(value: any): string {
    return String(value ?? '')
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  formatNextEventsHtml(nextEvents: any): string {
    LoggerService.log('Formatting next events data:', nextEvents);

    // Check if we have valid data
    if (!nextEvents) {
      return '<div class="next-events-container"><p>No upcoming appointments</p></div>';
    }

    // Check early if there are no upcoming events
    const hasNoUpcomingEvents =
      (!nextEvents.upcomingEventList || nextEvents.upcomingEventList.length === 0) &&
      (!nextEvents.upcomingEvent ||
        nextEvents.upcomingEvent === '<p>No Appointments Available</p>' ||
        nextEvents.upcomingEvent === '<p>Click for upcoming appointments</p>') &&
      (!nextEvents.nextdate || nextEvents.nextdate === 'NFA' || nextEvents.nextdate === ' NFA');

    if (hasNoUpcomingEvents) {
      LoggerService.log('No upcoming events found in data');
      return '<div class="next-events-container"><p>No upcoming appointments</p></div>';
    }

    // Create a fresh container for next events
    let html = '<div class="next-events-container">';
    html += '<h4>Upcoming Appointments</h4>';

    // If we have event list data, format it (prioritize this over upcomingEvent string)
    if (nextEvents.upcomingEventList && nextEvents.upcomingEventList.length > 0) {
      LoggerService.log(`Found ${nextEvents.upcomingEventList.length} upcoming events in list`);
      html += '<ul class="next-events-list">';

      // Show all events in the list, no limit
      nextEvents.upcomingEventList.forEach((event: any) => {
        // Handle both string dates and event objects
        if (typeof event === 'string') {
          const formattedDate = moment(event).format('ddd, MMM D, YYYY - h:mm A');
          html += `<li class="next-event-item">
            <i class="fa fa-calendar" aria-hidden="true"></i>
            ${formattedDate}
          </li>`;
        } else if (typeof event === 'object') {
          // For formatted event objects with title and dateFormatted
          const title = this.escapeHtml(event.title || '');
          const dateStr = this.escapeHtml(event.dateFormatted || event.date || '');

          // Extract actual date and time if present in different format
          let displayText = '';
          if (title) displayText += title;
          if (title && dateStr) displayText += ' - ';
          if (dateStr) displayText += dateStr;

          html += `<li class="next-event-item">
            <i class="fa fa-calendar" aria-hidden="true"></i>
            ${displayText}
          </li>`;
        }
      });

      html += '</ul>';
    }
    // Fallback to upcomingEvent if available and not a "no appointments" message
    else if (nextEvents.upcomingEvent &&
      nextEvents.upcomingEvent !== '<p>No Appointments Available</p>' &&
      nextEvents.upcomingEvent !== '<p>Click for upcoming appointments</p>') {

      LoggerService.log('Using upcomingEvent string for display');
      // Try to extract date information from the HTML string
      const dateMatch = nextEvents.upcomingEvent.match(/(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s+(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s+\d+,\s+\d+\s+-\s+\d+:\d+\s+(AM|PM)/);

      if (dateMatch) {
        const dateString = dateMatch[0];
        html += '<ul class="next-events-list">';
        html += `<li class="next-event-item">
          <i class="fa fa-calendar" aria-hidden="true"></i>
          ${dateString}
        </li>`;
        html += '</ul>';
      } else if (nextEvents.nextdate && nextEvents.nextdate !== 'NFA' && nextEvents.nextdate !== ' NFA') {
        // If we couldn't extract the date but have nextdate field (that's not NFA)
        html += '<ul class="next-events-list">';
        html += `<li class="next-event-item">
          <i class="fa fa-calendar" aria-hidden="true"></i>
          Next appointment: ${this.escapeHtml(nextEvents.nextdate)}
        </li>`;
        html += '</ul>';
      } else {
        // No upcoming appointments
        html += '<p>No upcoming appointments</p>';
      }
    } else if (nextEvents.nextdate && nextEvents.nextdate !== 'NFA' && nextEvents.nextdate !== ' NFA') {
      // If we only have nextdate (that's not NFA)
      LoggerService.log('Using nextdate for display:', nextEvents.nextdate);
      html += '<ul class="next-events-list">';
      html += `<li class="next-event-item">
        <i class="fa fa-calendar" aria-hidden="true"></i>
        Next appointment: ${this.escapeHtml(nextEvents.nextdate)}
      </li>`;
      html += '</ul>';
    } else {
      html += '<p>No upcoming appointments</p>';
    }

    html += '</div>';
    return html;
  }

  /**
   * Creates a consistent cache key for next events data regardless of date format
   *
   * @param eventId The event ID
   * @param dateStr Date string in any valid format
   * @returns A normalized cache key
   */
  private createNextEventsCacheKey(eventId: string, dateStr: string): string {
    try {
      // Parse the date string into a moment object and normalize to ISO format
      // but truncate to just include date portion to avoid time zone differences
      const normalizedDate = moment(dateStr).format('YYYY-MM-DD');

      return `next-events-${eventId}-${normalizedDate}`;
    } catch (error) {
      LoggerService.error(`[API] Error normalizing date for cache key: ${dateStr}`, error);
      // Fallback to original format
      return `next-events-${eventId}-${dateStr}`;
    }
  }

  /**
   * Centralized method to load next events data, used by both tooltip and event click
   *
   * @param eventId Event ID to fetch next events for
   * @param date Event date
   * @param studentId Optional student ID
   * @param onSuccess Callback function when data is successfully loaded
   * @param onError Callback function when error occurs
   * @returns void
   */
  private loadNextEvents(
    eventId: string,
    date: string,
    studentId: string | null,
    onSuccess: (data: any) => void,
    onError: (error: any) => void
  ): void {
    // Normalize the date format for consistent caching
    const normalizedDate = moment(date).format('YYYY-MM-DD');

    // Create consistent cache key
    const cacheKey = `next-events-${eventId}-${normalizedDate}`;

    // Log the source parameters
    LoggerService.log(`[NEXTEVENTS] Loading for event ${eventId} with date ${date}`);
    LoggerService.log(`[NEXTEVENTS] Using cache key: ${cacheKey}`);

    // Check if data is already in cache
    if (this.nextEventsCache.has(cacheKey)) {
      LoggerService.log(`[NEXTEVENTS] Using cached data for event ${eventId}`);
      onSuccess(this.nextEventsCache.get(cacheKey));
      return;
    }

    // Check if there's already a request in progress
    if (this.pendingRequests.has(cacheKey)) {
      LoggerService.log(`[NEXTEVENTS] Reusing in-flight request for event ${eventId}`);
      this.pendingRequests.get(cacheKey)
        .then(data => onSuccess(data))
        .catch(error => onError(error));
      return;
    }

    // Make a new request if not cached or pending
    LoggerService.log(`[NEXTEVENTS] Fetching data for event ${eventId}`);

    // Normalize the date for API requests
    const apiDateStr = moment(date).format('YYYY-MM-DDTHH:mm:ss');

    // Create the promise for the HTTP request
    const requestPromise = this.fetchNextEvents(studentId, eventId, apiDateStr);

    // Store the promise in the pending requests map
    this.pendingRequests.set(cacheKey, requestPromise);

    // Handle the response
    requestPromise
      .then(data => {
        LoggerService.log(`[NEXTEVENTS] Data received for event ${eventId}`);
        this.nextEventsCache.set(cacheKey, data);
        onSuccess(data);
      })
      .catch(error => {
        LoggerService.error(`[NEXTEVENTS] Error for event ${eventId}:`, error);
        onError(error);
      })
      .finally(() => {
        this.pendingRequests.delete(cacheKey);
      });
  }

  /**
   * Fetch next events for a specific event
   *
   * @param studentAccountId The student account ID (optional if can be determined from the event ID)
   * @param currentEventId The current event ID (required)
   * @param date The date of the event (required)
   * @returns A promise with the next events data
   */
  private fetchNextEvents(studentAccountId: string | null, currentEventId: string, date: string): Promise<any> {
    if (!currentEventId || !date) {
      LoggerService.error('[API] Missing required parameters for fetchNextEvents:', { studentAccountId, currentEventId, date });
      return Promise.reject('Missing required parameters');
    }

    let endpoint = `/api/dayview/calendar/next_events?current_event_id=${currentEventId}&date=${date}`;

    // Add student_account_id if available
    if (studentAccountId) {
      endpoint += `&student_account_id=${studentAccountId}`;
    }

    LoggerService.log(`[API] Making API request to: ${endpoint}`);

    // Create the promise for the HTTP request
    return new Promise<any>((resolve, reject) => {
      this._drupalRESTService.httpGET(endpoint)
        .subscribe({
          next: (data) => {
            if (!data) {
              LoggerService.warn(`[API] Empty response from API for event ${currentEventId}`);
              const emptyData = { upcomingEventList: [] };
              resolve(emptyData); // Return empty data structure
            } else {
              resolve(data);
            }
          },
          error: (error) => {
            LoggerService.error(`[API] Error fetching next events for event ${currentEventId}:`, error);
            reject(error);
          }
        });
    });
  }

  // Handle show tooltip for non-recurring events
  onShowTooltip(tooltip, event, isRecurring = false) {
    const hasNextEvents = event.hasNextEvents;
    const tooltipEl = document.getElementById('next-events-content');
    if (!tooltipEl) return;

    // Set initial loading state if we need to fetch next events
    if (hasNextEvents) {
      tooltipEl.innerHTML = '<div class="loading-spinner">Loading...</div>';
    } else {
      tooltipEl.innerHTML = '<p>No upcoming events.</p>';
    }

    if (hasNextEvents && event.id) {
      LoggerService.log(`[TOOLTIP] Show tooltip for event ${event.id}`);

      this.loadNextEvents(
        event.id,
        event.date,
        event.studentAccountId || null,
        (data) => {
          LoggerService.log(`[TOOLTIP] Data received for tooltip id=${event.id}`);
          const tooltipContent = this.formatNextEventsHtml(data);

          // Update tooltip content only if we have valid data
          if (tooltipContent && tooltipContent.trim() !== '') {
            tooltipEl.innerHTML = tooltipContent;
          } else {
            tooltipEl.innerHTML = '<p>No upcoming events.</p>';
          }
        },
        (error) => {
          LoggerService.error(`[TOOLTIP] Error loading events for tooltip id=${event.id}:`, error);
          tooltipEl.innerHTML = '<p>Failed to load upcoming events.</p>';
        }
      );
    }
  }

  /**
   * Process pending studio refresh if all dependencies are ready
   * Only executes if:
   * 1. Calendar is ready
   * 2. Studio timezone is loaded
   * 3. There's a pending refresh queued
   */
  private processPendingStudioRefresh(): void {
    if (this.pendingStudioRefresh && this.isCalendarReady && this.studioTimezoneLoaded) {
      LoggerService.log('[STUDIO] Processing queued studio refresh - all dependencies ready');
      LoggerService.log('[STUDIO] - Calendar ready:', this.isCalendarReady);
      LoggerService.log('[STUDIO] - Studio timezone:', this.studioTimezone);
      LoggerService.log('[STUDIO] - Studio timezone loaded:', this.studioTimezoneLoaded);

      this.pendingStudioRefresh = false;

      setTimeout(() => {
        this.refreshCalendar();
      }, 200);
    } else if (this.pendingStudioRefresh) {
      LoggerService.log('[STUDIO] Pending refresh waiting on dependencies:');
      LoggerService.log('[STUDIO] - Calendar ready:', this.isCalendarReady);
      LoggerService.log('[STUDIO] - Studio timezone loaded:', this.studioTimezoneLoaded);
    }
  }

  /**
   * Load studio timezone information
   */
  loadStudioTimeZoneInfo() {
    LoggerService.log('[TIMEZONE] Loading studio timezone info...');
    LoggerService.log('[TIMEZONE] Browser timezone:', Intl.DateTimeFormat().resolvedOptions().timeZone);
    LoggerService.log('[TIMEZONE] Current moment default timezone:', moment.tz.guess());

    // Called again on every studio switch: replace the previous subscription
    // rather than stacking another one per switch.
    this.studioConfigSubscription?.unsubscribe();
    this.studioConfigSubscription = this._studioConfigService.getStudioConfig().subscribe(
      (config) => {
        if (config) {
          this.studioTimezone = config?.['field_studio_timezone']?.[0]?.value || 'America/New_York';
          this.studioCountry = config?.['field_studio_address']?.[0]?.country_code || 'US';

          LoggerService.log('[TIMEZONE] Studio timezone loaded:', this.studioTimezone);
          LoggerService.log('[TIMEZONE] Studio country:', this.studioCountry);
          LoggerService.log('[TIMEZONE] Current time in browser:', moment().format('YYYY-MM-DD HH:mm:ss Z'));
          LoggerService.log('[TIMEZONE] Current time in studio TZ:', moment.tz(this.studioTimezone).format('YYYY-MM-DD HH:mm:ss Z'));

          // CRITICAL: Set timezone in options BEFORE marking as loaded (so calendar renders with correct TZ)
          this.calendarOptions.timeZone = this.studioTimezone;
          LoggerService.log('[TIMEZONE] Set calendarOptions.timeZone to:', this.calendarOptions.timeZone);

          // Now mark as loaded - this will trigger calendar to render (via *ngIf)
          this.studioTimezoneLoaded = true;
          LoggerService.log('[TIMEZONE] studioTimezoneLoaded flag set to:', this.studioTimezoneLoaded);

          // Note: Calendar will render with correct timezone via *ngIf guard
          // No need to update API or refetch since calendar hasn't rendered yet
          LoggerService.log('[TIMEZONE] Calendar will render with correct timezone when studioTimezoneLoaded triggers *ngIf');

          // Start the studio time timer
          this.startStudioTimeTimer();
        }
      },
      (error) => {
        LoggerService.error('Error loading studio timezone:', error);
        this.studioTimezone = 'America/New_York'; // Default fallback
        this.studioCountry = 'US';

        LoggerService.log('[TIMEZONE] Using fallback timezone:', this.studioTimezone);

        // CRITICAL: Set timezone in options BEFORE marking as loaded
        this.calendarOptions.timeZone = this.studioTimezone;
        LoggerService.log('[TIMEZONE] Set calendarOptions.timeZone to:', this.calendarOptions.timeZone);

        // Now mark as loaded - this will trigger calendar to render
        this.studioTimezoneLoaded = true;
        LoggerService.log('[TIMEZONE] studioTimezoneLoaded flag set to:', this.studioTimezoneLoaded);

        LoggerService.log('[TIMEZONE] Calendar will render with fallback timezone when studioTimezoneLoaded triggers *ngIf');
      }
    );
  }

  /**
   * Format timezone for display
   */
  getFormattedTimezone(): string {
    if (!this.studioTimezone) return '';

    // Extract city name from timezone (e.g., "America/New_York" -> "New York")
    const city = this.studioTimezone.split('/').pop()?.replace('_', ' ');

    // Get the current offset
    const offset = moment().tz(this.studioTimezone).format('Z');

    return `${city} (UTC${offset})`;
  }

  /**
   * Start the studio time timer
   */
  private startStudioTimeTimer(): void {
    // Clear any existing timer
    if (this.timerIntervalId) {
      clearInterval(this.timerIntervalId);
    }

    // Update immediately
    this.updateStudioTime();

    // Update every second
    this.timerIntervalId = setInterval(() => {
      this.updateStudioTime();
    }, 1000);
  }

  /**
   * Update the studio time display in the calendar header
   */
  private updateStudioTime(): void {
    if (!this.studioTimezone || !this.calendarComponent || !this.calendarComponent.getApi()) {
      return;
    }

    // Get current time in studio timezone
    const studioTime = moment.tz(this.studioTimezone);

    // Format time compactly: "3:45 PM EST"
    const timeStr = studioTime.format('h:mm A');
    const tzAbbr = studioTime.format('z'); // Get timezone abbreviation

    // Update the button text
    const calendarApi = this.calendarComponent.getApi();
    const studioTimeButton = document.querySelector('.fc-studioTime-button');

    if (studioTimeButton) {
      studioTimeButton.innerHTML = `<span style="font-size: 0.9em; font-weight: normal;">${timeStr} ${tzAbbr}</span>`;
    }
  }

  /**
   * Handle instructor selection changes from the toggle component
   * @param selectedInstructors Array of selected instructor IDs
   */
  onInstructorSelectionChanged(selectedInstructors: string[]): void {
    LoggerService.log('Instructor selection changed:', selectedInstructors);

    // Store the selected instructors
    this.filterInstructor = selectedInstructors;

    // Apply filtering using already-loaded data without network request
    this.applyResourceFiltering(selectedInstructors);
  }

  /**
   * Apply client-side resource filtering using already-loaded data
   * This avoids unnecessary network requests when toggling instructors
   * @param selectedInstructors Array of selected instructor IDs
   */
  private applyResourceFiltering(selectedInstructors: string[]): void {
    if (!this.calendarComponent || !this.calendarComponent.getApi()) {
      LoggerService.warn('Calendar not ready for resource filtering');
      return;
    }
    // The Website Booking tray only exists on days that hold web bookings, so
    // it is never in a selection made on another day: keep it whatever the
    // selection says, unless the selection is empty (then everything shows).
    if (selectedInstructors.length > 0) {
      const pinned = this.allResources.filter((r: any) => r?.webBookings).map((r: any) => String(r.id));
      selectedInstructors = Array.from(new Set([...selectedInstructors, ...pinned]));
    }

    const calendarApi = this.calendarComponent.getApi();

    // If no instructors selected, show all available resources
    if (selectedInstructors.length === 0) {
      this.showAllResources();
      return;
    }

    // Get currently visible resources
    const currentResources = calendarApi.getResources();
    const currentResourceIds = new Set(currentResources.map(r => r.id));
    const selectedResourceIds = new Set(selectedInstructors);

    // Remove resources that should be hidden
    currentResources.forEach(resource => {
      if (!selectedResourceIds.has(resource.id)) {
        resource.remove();
        this.currentlyVisibleResources.delete(resource.id);
      }
    });

    // Add resources that should be shown (from already-loaded data)
    selectedInstructors.forEach(resourceId => {
      if (!currentResourceIds.has(resourceId)) {
        const resourceData = this.allResources.find(r => r.id === resourceId);
        if (resourceData) {
          calendarApi.addResource(resourceData);
          this.currentlyVisibleResources.add(resourceId);
        }
      }
    });

    LoggerService.log(`Applied client-side resource filtering for ${selectedInstructors.length} selected instructors`);
  }

  /**
   * Show all available resources from already-loaded data
   */
  private showAllResources(): void {
    if (!this.calendarComponent || !this.calendarComponent.getApi()) {
      return;
    }

    const calendarApi = this.calendarComponent.getApi();
    const currentResources = calendarApi.getResources();
    const currentResourceIds = new Set(currentResources.map(r => r.id));

    // Add any missing resources from the already-loaded data
    this.allResources.forEach(resourceData => {
      if (!currentResourceIds.has(resourceData.id)) {
        calendarApi.addResource(resourceData);
        this.currentlyVisibleResources.add(resourceData.id);
      }
    });
  }

  /**
 * Mount the instructor toggle component in the FullCalendar header toolbar
 */
  /**
   * Attach hover tooltips to resource columns showing the time at mouse position
   * Only shows tooltip for session start times (gray slots)
   */
  private attachSlotTimeTooltips(): void {
    setTimeout(() => {
      // Get the resource columns (the actual clickable areas)
      const columns = document.querySelectorAll('.fc-timegrid-col.fc-resource');
      // Get all slot lanes to map Y position to time
      const slotLanes = document.querySelectorAll('.fc-timegrid-slot-lane[data-time]');

      if (columns.length === 0 || slotLanes.length === 0) return;

      // Get session start times for current day
      const getSessionTimesForCurrentDay = (): string[] => {
        if (!this.AMTSessionTime || !this.filterDate) return [];
        const dayName = moment(this.filterDate).format('dddd').toLowerCase();
        return this.AMTSessionTime[dayName] || [];
      };

      columns.forEach((col: Element) => {
        // Skip if already processed
        if ((col as any)._slotTooltipAttached) return;
        (col as any)._slotTooltipAttached = true;

        const colEl = col as HTMLElement;
        let tooltipInstance: any = null;
        let lastTime = '';

        let mouseX = 0;
        let mouseY = 0;

        const showTooltip = (e: MouseEvent) => {
          mouseX = e.clientX;
          mouseY = e.clientY;

          // Don't show if hovering over an event (event tooltips take priority)
          const target = e.target as HTMLElement;
          if (target.closest('.fc-event')) {
            if (tooltipInstance) {
              tooltipInstance.destroy();
              tooltipInstance = null;
            }
            return;
          }

          // Find which slot lane corresponds to this Y position
          for (let i = 0; i < slotLanes.length; i++) {
            const lane = slotLanes[i] as HTMLElement;
            const rect = lane.getBoundingClientRect();

            if (mouseY >= rect.top && mouseY < rect.bottom) {
              const timeAttr = lane.getAttribute('data-time');
              if (timeAttr && timeAttr !== lastTime) {
                lastTime = timeAttr;

                // Check if this time is a session start time
                const sessionTimes = getSessionTimesForCurrentDay();
                const isSessionStartTime = sessionTimes.includes(timeAttr);

                if (isSessionStartTime) {
                  const formattedTime = moment(timeAttr, 'HH:mm:ss').format('h:mm A');

                  if (!tooltipInstance) {
                    tooltipInstance = tippy(colEl, {
                      content: formattedTime,
                      placement: 'right',
                      arrow: true,
                      animation: 'fade',
                      duration: [100, 50],
                      theme: 'light',
                      trigger: 'manual',
                      offset: [15, 0],
                      getReferenceClientRect: () => ({
                        width: 0,
                        height: 0,
                        top: mouseY,
                        bottom: mouseY,
                        left: mouseX,
                        right: mouseX,
                        x: mouseX,
                        y: mouseY,
                        toJSON: () => {},
                      }),
                    });
                    tooltipInstance.show();
                  } else {
                    tooltipInstance.setContent(formattedTime);
                    tooltipInstance.popperInstance?.update();
                  }
                } else {
                  // Not a session start time - hide tooltip if showing
                  if (tooltipInstance) {
                    tooltipInstance.destroy();
                    tooltipInstance = null;
                  }
                }
              }
              break;
            }
          }
        };

        const hideTooltip = () => {
          if (tooltipInstance) {
            tooltipInstance.destroy();
            tooltipInstance = null;
            lastTime = '';
          }
        };

        colEl.addEventListener('mouseenter', showTooltip);
        colEl.addEventListener('mousemove', showTooltip);
        colEl.addEventListener('mouseleave', hideTooltip);
      });
    }, 200);
  }

  private mountInstructorToggleInHeader(): void {
    setTimeout(() => {
      const instructorToggleButton = document.querySelector('.fc-instructorToggle-button');
      if (instructorToggleButton && this.instructorToggleRef && !instructorToggleButton.querySelector('app-instructor-toggle')) {
        // Move the Angular component element to the header button
        const instructorToggleElement = this.instructorToggleRef.nativeElement;

        // Clear the button content and append our component
        instructorToggleButton.innerHTML = '';
        instructorToggleButton.appendChild(instructorToggleElement);

        // Show the component (it was hidden initially)
        instructorToggleElement.style.display = 'block';

        // Apply some styling to make it fit in the header
        (instructorToggleButton as HTMLElement).style.padding = '0';
        (instructorToggleButton as HTMLElement).style.border = 'none';
        (instructorToggleButton as HTMLElement).style.background = 'transparent';
        (instructorToggleButton as HTMLElement).style.marginRight = '12px';
      }
    }, 100);
  }

  /**
   * Attach click handler to the calendar title to open the date picker
   */
  private attachTitleClickHandler(): void {
    setTimeout(() => {
      const titleElement = document.querySelector('.desktop-day-view .fc-toolbar-title') as HTMLElement;
      if (titleElement && !titleElement.classList.contains('clickable-title')) {
        titleElement.classList.add('clickable-title');
        titleElement.addEventListener('click', () => {
          if (this.filterComponent) {
            this.filterComponent.openFlatpickr(titleElement);
          }
        });
      }
    }, 50);
  }
}
